import {
	title
} from 'echarts/lib/theme/dark';
import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
	common: {
		setbtn: 'Set',
		link: 'Friendly Link',
		more: 'More Information',
		website: 'Official website',
		global: 'Worldwide',
		goods: 'Goods',
		service: 'Service',
		mallExchange1: 'Directly Connected Merchants',
		mallExchange2: 'Chain Merchant Platform',
	},
	commonTime: {
		minute1: '1 Minute',
		minute5: '5 Minutes',
		minute15: '15 Minutes',
		minute30: '30 Minutes',
		hour1: '1 Hour',
		hour2: '2 Hours',
		hour4: '4 Hours',
		day1: '1 Day',
		week1: '1 Week',
		month1: '1 Month',
	},
	"tipsVal": {
		"copyerror": "Copy failed!",
		"copySucess": "Copied successfully!",
		"noDataTips": "No data available~",
		"noBankCardTips": "No bank card information added yet~",
		"inputPlaceholder": "Please enter content",
		"inputPlaceholder1": "Please enter",
		"networkType": "Network Type",
		"phone": "Phone",
		"logoutTips": "This operation will log you out, continue?",
		"setChoiceAddress": 'Set withdrawal address'
	},
	verifyUser: {
		title: "Identity Authentication",
		country: "Residence",
		name: "name",
		familyName: "Surname",
		idcardNo: "ID number",
		upload: "Upload",
		Reminder: "Attention",
		reminderValue: "· Ensure that your name and ID number are clearly visible in the photo",
		tips: {
			type: "in PEG or PNG format,",
			size: "No more than 2MB",
			idcardImg: "Please upload a photo of your ID card",
			idcardFrontImgurl: "Upload a photo of the front page of your identity document in PNG or JPEG format",
			idcardBackImgurl: "Upload the back of your ID card in PNG or JPEG format,",
		}
	},
	"vip": {
		"register": "Registered User",
		"member": "Member",
		"copartner": "Partner",
		"diamond": "Diamond Partner"
	},
	"news": {
		"title": "News, Events & Announcements",
		"titleInfo": "Focus on industry depth and frontiers, in-depth analysis of trends and opportunities",
		"tabVal1": "System Notifications",
		"tabVal2": "Platform Announcements",
		"tabVal3": "News & Events",
		"tabVal4": "Research Report",
		"moreTips": "More Announcements",
		"noDataTips": "No content yet~"
	},
	"buy_box": {
		"buy": "Buy",
		"buy_price": "Bid",
		"sell": "Sell",
		"sell_price": "Ask",
		"use": "Available",
		"amount": "Quantity",
		"money": "Amount",
		"loading": "Login",
		"add_success": "Order placed successfully",
		"trans_confirm": "Trade Confirmation",
		"buy_confirm": "Confirm Buy",
		"sell_confirm": "Confirm Sell",
		"trans_amount": "Transaction Amount",
		"trans_password_placeholder": "Please enter transaction password",
		"confirm": "Confirm",
		"cancel": "Cancel",
		"verification": "Verify",
		"withdraw": "Withdraw",
		"chain_withdraw": "On-chain Withdrawal",
		"input_error": "Amount or quantity must be greater than 0"
	},
	"nav": {
		"home": "Home",
		"mall": "Mall",
		"ctc": "Secondhand Market",
		'second_hand_market': 'second-hand market',
		"otc": "Fiat Trading",
		"faq": "FAQ",
		"partner": "Member",
		"financial": "RWA Financial",
		"burst": "Block Burst Reward",
		"apply": "Listing Application",
		"download": "APP Download",
		"order": "Orders",
		"assets": "Assets",
		"login": "Login/Register",
		"mine": "My Account",
		"ann_more": "View More >>",
		"ann_drop": {
			"system": "System Notifications",
			"ann": "Platform Announcements",
			"news": "Industry News",
			"login": "Log in to view"
		},
		"user_drop": {
			"partner_register": "Registered User",
			"partner_member": "Member",
			"partner_partner": "Partner",
			"partner_diamond": "Diamond Partner",
			"center": "Personal Center",
			"address": "Withdrawal Address Management",
			"order": "Order Management",
			"receipt": "Payment Settings",
			"api": "API Management",
			"out": "Logout"
		}
	},
	mall: {
		title: "Mall",
		status1: "In Progress",
		status2: "Not Started",
		status3: "Subscription Ended",
		status4: "Subscription N/A",
		assetType: "Asset Category",
		assetTime: "Release Date",
		assetPrice: "Issuance Price",
		issuanceTotal: "Total Issuance Value",
		outstandingUnits: "Outstanding Units",
		delivery: "Delivery Region",
		payPrice: "Minimum Purchase",
		typeGoods: "Goods",
		typeService: "Service",
		mallUrl: "Chain Mall",
		showDetail: "Click to View Details",
		subscription_price: "Subscription Price",
		share_quantity: "Share Quantity",
		total_supply: "Total Supply",
		total_value: "Total Value",
		shares_unit: "shares",
		issue_unit: "shares",
		pieces_per_share: "pcs/share",
		pre_sale: "Pre-sale",
		open_sale: "Open Sale",
		view_details: "View Details",
		starts: "Starts",
		ends: "Ends",
		detail: {
			title: 'Product Details',
			type: 'BNB Smart Chain',
			typeInfo: 'Issued by MEIMEI INTERNATIONAL HOLDINGS LIMITED',
			btn1: 'Enter Secondary Market',
			btn2: 'Chain Business Platform',
			tab1: 'Details',
			tab2: 'Documents',

			goodsType: "Product Type",
			mallExchange: "Redemption",
			debutStartTime: "Pre-sale Start",
			debutEndTime: "Pre-sale End",
			goodsName: "Listing Name",
			symbol: "Ticker Symbol",
			network: "Network",
			protocol: "Protocol",
			contract: "Contract Address",
			issuer: "Issuer",
			publishAmount: "Total Issuance",
			tradeAmount: "Total Trading Volume",
			decimal: "Decimal Precision",
			totalValue: "Total Issuance Value",
			firstValue: "Initial Issuance",
			minBuyAmount: "Minimum Purchase Amount",
			maxBuyAmount: "Maximum Purchase Amount",
			showWhitePage: "View Whitepaper",

			chainInfo: "On-chain Information",
			view: "View",
			hide: "Hide",

			noData: "No mall products available yet~",

			coinInfo1: 'Hong Kong Top 100 Listed Companies Alliance Limited',
			coinInfo2: 'RWA Group Limited',
			coinInfo3: 'Meimei International Holdings Limited',
		}
	},
	mallDetail: {
		title: "Token Details",
		issue_price: "Issue Price",
		issue_amount: "Issue Amount",
		min_buy_shares: "Min Buy Shares",
		max_buy_shares: "Max Buy Shares",
		subscription_period: "Subscription Period",
		distribution_start: "Distribution Start",
		distribution_end: "Distribution End",
		start_trading: "Start Trading",
		purchase_info: "Purchase Info",
		max_subscription: "Max Subscription",
		purchase_price: "Purchase Price",
		subscribed: "Subscribed",
		share: "share",
		whitelist_info: "Whitelist Info",
		whitelist_status: "Whitelist Status",
		whitelist_max: "Whitelist Max Buy",
		remaining_buy: "Remaining Buy",
		enabled: "Enabled",
		disabled: "Disabled",
		chain_info: "Chain Info",
		network: "Network",
		blockchain: "Blockchain",
		protocol: "Protocol",
		contract_address: "Contract Address",
		whitepaper: "Whitepaper",
		explorer: "Explorer",
		view_whitepaper: "View Whitepaper",
		copy: "Copy",
		copy_success: "Copy Success",
		copy_fail: "Copy Fail",
		faq: "FAQ",
		buy_now: "Buy Now",
		ended: "Ended",
		waiting: "Waiting",
		will_open: "Will Open",
		please_login: "Please Login",
		non_whitelist: "Not in Whitelist",
		exceed_max_buy_shares: "Exceed Max Buy Shares",
		started: "Started",
		day: "d",
		hour: "h",
		minute: "m",
		second: "s",
		sold_progress: "Sales Progress",
		sold: "Sold",
		remaining: "Remaining",
	},
	"question": {
		"title": "Frequently Asked Questions",
		"info1": "What kind of platform does RWA.LTD provide for users?",
		"infoText1": "What kind of platform does RWA.LTD provide for users?",
		"info2": "Requirements and restrictions for registering as a platform user",
		"infoText2": "Requirements and restrictions for registering as a platform user",
		"info3": "Requirements and restrictions for registering as a platform user",
		"infoText3": "This platform offers an invitation reward campaign for users who have completed KYC verification. If an invited user registers an account through an invitation link or code and completes KYC verification, the inviting user can receive rebates on the invited user's future buy transaction fees (15% for first level, 5% for second level). After KYC verification is approved, you can obtain your invitation code in 'Personal Center - Account Management - View My Invitation'. New users can also bind the invitation relationship by clicking the invitation link. This platform reserves the right to modify or cancel the aforementioned campaign at any time. Such 'updates' or 'cancellations' may not be promptly reflected here.",
		"info4": "Why can't I register or log in successfully?",
		"infoText4": "Why can't I register or log in successfully?",
		"info5": "How to purchase the platform's Genesis Token RWA Coin ('RWA')?",
		"infoText5": "How to purchase the platform's Genesis Token RWA Coin ('RWA')?"
	},
	"home": {
		"header": {
			"title1": "Chain Commerce Platform Grand Launch",
			"title2": "Innovative combination of token mechanism and consumer economy, bringing you a brand new experience",
			"title": "RWA Exchange",
			"con": "Millionaire Partner Program",
			"rules": "View Event Details >>",
			"member_num": "Member Count",
			"register_num": "Registered Users",
			"register_btn": "Click to Register"
		},
		"table": {
			"header": {
				"userCollect": "Favorites",
				"search": "Search trading pairs"
			},
			"row": {
				"rwatype": "RWA Token",
				"type": "Trading Pair",
				"price": "Reference Price",
				"high": "24H High",
				"low": "24H Low",
				"rang": "24H Change",
				"volume": "24H Volume",
				"amount": "24H Turnover",
				"operation": "Action",
				"buy": "Buy",
				"sell": "Sell"
			},
			"more": "View More"
		},
		"introduction": {
			"h1": "RWA Exchange, the world's largest membership-based exchange",
			"h3": "Providing global users with secure, reliable digital asset trading and asset management services, sharing platform benefits with members worldwide",
			"part1": {
				"title": "Innovative Membership System",
				"con": "Adopting a community co-construction, member-benefit sharing approach to build the world's largest membership-based exchange"
			},
			"part2": {
				"title": "Stable and Reliable System",
				"con": "Multi-layer multi-cluster system architecture, high-performance matching engine technology, bank-level user data encryption, dynamic identity verification, etc., ensuring trading security"
			},
			"part3": {
				"title": "Guaranteed Fund Security",
				"con": "Advanced technologies such as multi-signature, offline signatures, and combined hot/cold wallets provide customers with secure and reliable digital asset trading services"
			},
			"title": {
				"merchant1": "Seller",
				"merchant2": "Buyer",
				"text1": "Innovative Reform of the Consumer Economy",
				"text2": "RWA.LTD provides buyers and sellers with trading channels and models in the WEB3 era through the innovative combination of token mechanisms and consumer markets.",
				"text3": "Customized Non-Financial Asset Sales Solutions",
				"text4": "RWA.LTD will tailor-make asset sales solution designs and technical execution according to your specific needs.",
				"text5": "Low-Threshold Token Retail Trading and Collecting",
				"text6": "RWA.LTD will provide you with value-backed tokenized non-financial assets and build an innovative and efficient breakthrough trading platform integrating trading and collecting, striving to enable everyone to experience and enjoy the tremendous improvements blockchain trading brings to the consumer economy.",
				"text7": "Rewriting the Consumer Economy as a Chain Commerce Economy",
				"text8": "Through a diverse yet high-quality selection of non-financial assets, a retail user profile design for everyone, and a breakthrough integration of trading and collecting, RWA.LTD is rooted in the real economy, prioritizing user rights, and strives to provide everyone with a trustworthy, value-backed token trading platform that can practically utilize the benefits of blockchain technology.",
				"text9": "News, Events & Announcements",
				"text10": "More Announcements"
			}
		},
		"download": {
			"title": "Trade anytime, anywhere, more easily",
			"con": "RWA Exchange provides users with trading terminals supporting IOS, Android, and Web, and offers API services with millisecond-level latency for professional traders. Languages include Chinese, English, etc., dedicated to providing customers with a first-class investment experience.",
			"ios": "IOS Download",
			"android": "Android Download"
		},
		"register": {
			"title": "Register a RWA account, start your digital currency journey",
			"placeholder": "Please enter phone number or email",
			"btn": "Register Now"
		},
		"footer": {
			"about": "About Us",
			"legal": 'Platform Terms and Conditions',
			"terms": "Terms of Use",
			"buyProtocol": "Purchase Agreement",
			"questions": "FAQ",
			"ecosystem": "Ecosystem",
			"rwaApp": "RWA App",
			"emailAddress": "Email Address",
			"companyaddress": "Company Address",
			"production": "Products",
			"question": "Feedback",
			"rate": "Fee Schedule",
			"partner": "Become a Partner",
			"apply": "Listing Application",
			"api": "API Access",
			"app": "App Download",
			"ann_help": "Announcement Help",
			"off_ann": "Official Announcements",
			"help": "Help Center",
			"agreements": "User Agreement",
			"privacy": "Privacy Policy",
			"contact": "Contact Us",
			"business": "Business Cooperation",
			"service": "Customer Service",
			"institutional": "Institutional Cooperation"
		},
		"v2": {
			"hero": {
					"tag": "RWA.LTD · CONSUMER RWA INFRASTRUCTURE",
					"title1": "Connecting Real-World Assets",
					"title2": "On-Chain Circulation.",
					"title3": "Creating Platform Value.",
					"desc": "RWA.LTD connects real goods, services and commercial rights with transparent digital representation, on-chain circulation and real-world fulfilment.",
					"btn1": "Explore Consumer RWA",
					"btn2": "Watch the Film",
					"tag1": "Products & Brands",
					"tag2": "Commerce",
					"tag3": "Fulfilment"
				},
			"banners": {
				"card1": "RWA.ltd New Version Released, Members Enjoy Multiple Real-World Exclusive Benefits",
				"card2": "GCT, the world's first Chain Commerce Coffee RWA, is now live on rwa.ltd",
				"card3": "Brand New Upgrade The Official New Website of RWA.LTD Is Live",
				"card4": "Focused on the blockchain token mall, enjoy hassle-free shopping",
				"btn": "Click to View"
			},
			"quotes": {
				"title1": "Hot Market Quotes",
				"title2": "Secondhand Market",
				"desc": "Stay updated on the latest cryptocurrency price movements and seize every trading opportunity. RWA delivers industry-leading liquidity and market depth.",
				"totalAssets": "Total Assets",
				"todayPnl": "Today's P&L",
				"viewManage": "View & Manage Assets",
				"partner": "Partner Program",
				"viewAll": "View All"
			},
			"news": {
				"title1": "News, Events & ",
				"title2": "Announcements",
				"viewAll": "View All",
				"explore": "Explore"
			},
			"consumer": {
				"eyebrow": "CONSUMER RWA MODEL",
				"title1": "From physical goods",
				"title2": "and services to manageable digital rights",
				"item1": {
					"title": "Real Commercial Value",
					"desc": "Goods, services, memberships and benefits grounded in real commerce."
				},
				"item2": {
					"title": "Digital Representation",
					"desc": "Rights represented digitally with clear rules and verifiable project materials."
				},
				"item3": {
					"title": "Circulation & Redemption",
					"desc": "Connected circulation with a route back to real products and services."
				}
			},
			"solutions": {
				"eyebrow": "SOLUTIONS",
				"title1": "From idea",
				"title2": "to issuance, circulation and redemption",
				"link": "Explore the lifecycle",
				"items": {
					"commonExplore": "Explore",
					"issuance": {
						"title": "Issuance & Redemption Design",
						"desc": "Token rules, rights structure and redemption logic"
					},
					"materials": {
						"title": "Core Project Materials",
						"desc": "Whitepapers, project guides and essential documentation"
					},
					"deployment": {
						"title": "Blockchain Deployment",
						"desc": "Secure, scalable deployment aligned with the project model"
					},
					"launch": {
						"title": "Launch & Brand Communication",
						"desc": "Go-to-market storytelling and project communication"
					},
					"circulation": {
						"title": "Platform Circulation",
						"desc": "Connections across platforms, users and commerce channels"
					},
					"redemption": {
						"title": "Redemption & Fulfilment",
						"desc": "Real-world delivery, service access and benefit fulfilment"
					}
				}
			},
			"projects": {
				"eyebrow": "SELECTED ECOSYSTEM PROJECTS",
				"title1": "Real projects. ",
				"title2": "Real commercial value",
				"viewAll": "View All",
				"end": "END",
				"explore": "Explore"
			},
			"discuss": {
				"title1": "Build the next generation of real-world",
				"title2": "digital commerce",
				"button": "Discuss Your Project"
			},
			"film": {
				"p1": "ANIMATED PLATFORM FILM",
				"title1": "RWA.LTD Platform",
				"title2": "Driving Real Value On-Chain",
				"desc": "See how real-world assets move from definition and issuance to circulation and fulfilment.",
				"btn": "Watch the Film"
			},
			"infrastructure": {
				"eyebrow": "ABOUT RWA.LTD",
				"title": "Infrastructure for the future",
				"title2": "of real-world digital commerce",
				"desc1": "RWA.LTD is a Consumer RWA platform that helps brands, project owners and merchants issue, circulate and redeem digital commercial rights backed by real-world assets and services.",
				"desc2": "We connect project structure, digital deployment, communication, platform circulation and fulfilment within one coherent lifecycle.",
				"button": "Discover our model"
			}
		}
	},
	"trade_ctc": {
		"trans_start": " before trading starts",
		"header": {
			"price": "Reference Price",
			"change": "24H Change",
			"high": "24H High",
			"low": "24H Low",
			"volume": "24H Volume",
			"search": "Search Currency",
			"self": "Favorites"
		},
		"buyAndSell": {
			"price": "Price",
			"volume": "Quantity",
			"money": "Amount",
			"limit_delegation": "Limit Order",
			"current_delegation": "Current Orders",
			"history_delegation": "Order History"
		},
		"delegationTable": {
			"time": "Order Time",
			"pay_type": "Trade Type",
			"buy": "Buy",
			"sell": "Sell",
			"amount": "Order Quantity",
			"beenDone": "Filled",
			"price": "Order Price",
			"averagePrice": "Average Fill Price",
			"money": "Total Filled Amount",
			"status": "Status",
			"trading": "Trading",
			"un_trade": "Pending",
			"canceled": "Canceled",
			"part_completed": "Partially Filled",
			"canceling": "Canceling",
			"completed": "Filled",
			"operation": "Action",
			"cancel": "Cancel",
			"cancel_success": "Canceled successfully",
			"deleteRecord": "Delete",
			"delete_success": "Deleted successfully"
		},
		"deal": {
			"title": "Latest Trades",
			"amount": "Quantity",
			"price": "Price",
			"time": "Time"
		},
		"search": {
			"placeholder": "Search Currency",
			"self": "Favorites",
			"coin_type": "RWA Token",
			"price": "Reference Price",
			"range": "Change"
		}
	},
	"login": {
		"title1": "Welcome",
		"title": "Welcome to RWA",
		"pwd": "Password",
		"tips": "Not a registered user yet?",
		"phone_login": "Phone Login",
		"email": "Email",
		"newemail": "New Email Address",
		"newemailcode": "New Email Verification Code",
		"email_login": "Email Login",
		"input_phone1": "Phone Number",
		"input_phone": "Phone Number (Mainland China only)",
		"input_email": "Please enter email",
		"input_email1": "Please enter a valid email",
		"input_password": "Please enter password",
		"login": "Login",
		"forget": "Forgot Password?",
		"no_account": "Don't have an account yet?",
		"register_now": "Register Now",
		"verify": "Verify",
		"close": "Close",
		"code_input": "Please enter verification code"
	},
	"register": {
		"title1": "Welcome",
		"title": "Welcome to RWA",
		"phone": "Phone Number",
		"register_phone": "Phone Registration",
		"register_email": "Email Registration",
		"input_phone": "Please enter phone number",
		"input_email": "Please enter email",
		"code": "Verification Code",
		"get_code": "Get Code",
		"input_code": "Please enter verification code",
		"input_mes_code": "Please enter SMS verification code",
		"input_email_code": "Please enter email verification code",
		"input_password": "Please set login password, 8-32 characters including numbers, letters, or symbols",
		"confirm_password": "Please enter password again",
		"invite_code": "Invitation Code",
		"invite_code_tip": "Please enter invitation code",
		"register": "Register",
		"agree1": "I have read and agree to the User Agreement",
		"agree": "I have read and agree to",
		"policy": "the 'User Agreement and Privacy Policy'"
	},
	"alert": {
		"register_success": "Registration successful"
	},
	"validate": {
		"account_require": "Account cannot be empty",
		"password_require": "Password cannot be empty",
		"code_require": "Verification code cannot be empty",
		"mes_code_require": "SMS verification code cannot be empty",
		"email_code_require": "Email verification code cannot be empty",
		"google_code_require": "Google verification code cannot be empty",
		"password_formatter_error": "Password format error",
		"password_formatter_tip": "Password must be 8 to 32 characters combining numbers and letters",
		"password_confirm_again": "Please enter password again",
		"password_confirm_error": "Passwords do not match",
		"phone_require": "Please enter phone number",
		"email_require": "Please enter email",
		"email_formatter_error": "Email format error",
		"country_require": "Please select your place of residence",
		"name_require": 'The surname cannot be empty',
		"familyName_require": 'The family name cannot be empty',
		"id_require": "ID number cannot be empty",
		"depositBank_require": "Bank name cannot be empty",
		"bankNum_require": "Bank card number cannot be empty",
		"bankNum_confirm_error": "Card numbers entered twice do not match",
		"trans_password_require": "Transaction password cannot be empty",
		"trans_password_formatter_tip": "Transaction password is 6-32 digits or letters",
		"alipay_account_require": "Alipay account cannot be empty",
		"wechat_account_require": "WeChat account cannot be empty",
		"geet_require": "Please complete verification",
		"agree_require": "Please read the user agreement first",
		"address_require": "Address cannot be empty",
		"amount_require": "Quantity cannot be empty",
		"amount_min": "Cannot be less than",
		"amount_over_0": "Please enter a number greater than 0",
		"type_number": "Must be a number",
		"incomplete_information": "Information incomplete",
		"coin_type_error": "Currency type error",
		"alias_require": "Address alias cannot be empty",
		"invite_code_require": "Invitation code cannot be empty",
		"description_require": "Remarks cannot be empty",
		"roles_require": "Please select API permissions",
		"qr_code_require": "Please upload QR code",
		"upload_error": 'Failed to upload image!',
		"upload_type": 'Uploaded images must be in JPG, JPEG, or PNG format!',
		"upload_size": 'The size of the uploaded avatar image cannot exceed 2MB!',
		"upload_compress": 'The image is large and is currently being compressed ...',
		"input_err_tips": "Please enter the correct content~"
	},
	"user_center": {
		"tip": "Tip",
		"tip_val2": "Used for fiat compliance deposits/withdrawals. Please use your own account and ensure information is correct and reliable!",
		"my_share": "My Invitation",
		"my_invite_code": 'My Invitation Code',
		"securitySettings": "Security Settings",
		"login_history": "Login History",
		"login_safety_history": "Security Settings History",
		"login_text": "Account Login",
		"login_out_text": "Logout",
		"copy_share_url": "Copy Invitation Link",
		"share_tips_val": "Daily at 08:00:00 (GMT+0800), referral rewards from the previous 24 hours will be refunded and directly deposited into your spot account. Please check your balance.",
		"accountManagement": "Account Management",
		"accountSettings": "Account Settings",
		"apiManagement": "API Management",
		"paySettings": "Payment Settings",
		"orderManagement": "Order Management",
		"saleOrder": "Sale Order",
		"marketOrder": "Market Order",
		"see_user_share": "View My Invitation",
		"update_user_img": "Change Avatar",
		"need_bind": "Need to bind both phone number and email",
		"need_bind1": "Need to bind both Google Authenticator and email",
		"bind_now": "Bind Now",
		"need_tran_password": "Need to set transaction password",
		"set_now": "Set Now",
		"need_auth": "Identity verification required",
		"kyc_phone": "Please complete identity verification on mobile",
		"i_know": "I understand",
		"cancel": "Cancel",
		"base_info": {
			"title": "Basic Information"
		},
		"account_setting": {
			"title": "Account Settings",
			"add": "Add",
			"manage": "Manage",
			"setting": "Settings",
			"address": {
				"title": "Withdrawal Address Management",
				"tip": "Address verification for security"
			},
			"receipt": {
				"title": "Payment Settings",
				"tip": "Ensure account security"
			},
			"api": {
				"title": "API Settings",
				"tip": "Create API keys"
			}
		},
		"account_safe": {
			"title": "Account Security",
			"title_tip": "At least two verification methods must remain active",
			"authenticate": "Verify",
			"not_authenticate": "Not Verified",
			"has_authenticate": "Certified",
			"has_authenticate_lvl": "Advanced Verification Completed",
			"ing_authenticate": "Under Review",
			"fail_authenticate": "Review Failed",
			"fail_reason": "Failure reason:",
			"authenticate_again": ", re-verify?",
			"again": "Re-verify",
			"close": "Close",
			"detail": "Details",
			"bind": "Bind",
			"setting": "Settings",
			"has_bind": "Bound",
			"not_bind": "Not Bound",
			"open": "Enable",
			"not_open": "Disabled",
			"has_open": "Enabled",
			"change": "Change",
			"modify": "Modify",
			"get_back": "Retrieve",
			"identity": {
				"title": "Identity Verification",
				"tipsVal": "Identity verification for your rights and interests"
			},
			"login_password": {
				"title": "Login Password",
				"tip": "Ensure account security"
			},
			"trade_password": {
				"btn": "Set",
				"title": "Transaction Password",
				"tip": "Ensure account security"
			},
			"phone": {
				"title": "Bind Phone",
				"tipsVal": "Used for withdrawals, password changes, and security settings via SMS verification"
			},
			"email": {
				"title": "Bind Email",
				"tipsVal": "Used for login, withdrawals, and security settings"
			},
			"google": {
				"title": "Google Authenticator",
				"bind": "Bind Google",
				"title1": "Google Verification Code",
				"tipsVal": "Used for security verification during withdrawals, password recovery, security settings changes, and API management",
				"tipsVal2": 'Please bind Google Authenticator first.'
			},
			"authenticate_trade": {
				"title": "Trade Verification",
				"tip": "Ensure account security"
			},
			"alert": {
				"con": "After disabling security verification, withdrawals and OTC trading will be prohibited for 24 hours.",
				"close_phone_title": "Confirm to disable phone verification?",
				"close_email_title": "Confirm to disable email verification?",
				"close_google_title": "Confirm to disable Google verification?",
				"cancel": "Cancel",
				"confirm": "Confirm"
			}
		},
		"table": {
			"login_recently": {
				"type": "Type",
				"title": "Recent Logins",
				"time": "Time",
				"ways": "Login Method",
				"status": "Status",
				"status1": "Current Status",
				"address": "Login Location",
				"address1": "Login Address",
				"success": "Login Successful",
				"error": "Failed",
				"success1": "Success",
			"fail": "Login Failed",
				"unknown": "Unknown"
			},
			"setting_history": {
				"title": "Security Settings History",
				"time": "Time",
				"safe_setting": "Security Setting",
				"address": "Login Location"
			}
		}
	},
	"phone_bind": {
		"title": "Bind Phone",
		"success": "Phone number bound successfully"
	},
	"google_bind": {
		"user_center": "Personal Center",
		"google_validate": "Bind Google Authenticator",
		"google_change": "Change Google Authenticator",
		"tip": "Google Authenticator is a dynamic password tool that works similarly to SMS dynamic verification. After binding, a dynamic verification code is generated every 30s, which can be used for security verification during login, withdrawals, security settings changes, etc.",
		"download_title": "Download Google Authenticator APP",
		"download_desc": "iOS users: Search 'Authenticator' in the App Store to download. Android users: Search 'Google Authenticator' in the app store or use a mobile browser to download.",
		"add_title": "Add Key in Google Authenticator and Backup",
		"add_desc": "Open Google Authenticator, scan the QR code below or manually enter the key below to add a verification token.",
		"copy_key": "Copy Key",
		"add_tip": "The key is used to recover Google Authenticator if your phone is changed or lost. Please be sure to back up and save the key below before binding.",
		"change_tip": "After changing the bound Google Authenticator, withdrawals and OTC trading will be prohibited for 24 hours.",
		"input_code": "Enter the 6-digit verification code from Google Authenticator",
		"google_code_placeholder": "Please enter Google verification code",
		"success_tip": "Binding Complete",
		"success_tip2": "The key is used to recover Google Authenticator if your phone is changed or lost. Please be sure to back up and save the above key before binding.",
		"next": "Next",
		"bind_title": "Bind Google Security Verification",
		"change_title": "Change Google Security Verification",
		"phone_code": "SMS Verification Code",
		"email_code": "Email Verification Code",
		"get_code": "Get Code",
		"code_placeholder": "Please enter verification code",
		"email_code_tip": "If you haven't received the email, please check your spam folder.",
		"confirm": "Confirm",
		"cancel": "Cancel",
		"success": "Google verification bound successfully",
		"change_success": "Google verification changed successfully"
	},
	"validation_off": {
		"title_phone": "Disable Phone Verification",
		"tip_phone": "After disabling phone verification, withdrawals and OTC trading will be prohibited for 24 hours.",
		"title_email": "Disable Email Verification",
		"tip_email": "After disabling email verification, withdrawals and OTC trading will be prohibited for 24 hours.",
		"title_google": "Disable Google Verification",
		"tip_google": "After disabling Google verification, withdrawals and OTC trading will be prohibited for 24 hours.",
		"phone": "Phone Number",
		"email": "Email",
		"phone_placeholder": "Please enter phone number",
		"phone_code": "SMS Verification Code",
		"code_placeholder": "Please enter verification code",
		"email_code": "Email Verification Code",
		"google_code": "Google Verification Code",
		"confirm": "Confirm",
		"phone_off_success": "Phone verification disabled",
		"email_off_success": "Email verification disabled",
		"google_off_success": "Google verification disabled",
		"google_lost": "Lost Google verification code?",
		"please_click": "Please click here"
	},
	"validation_on": {
		"title_phone": "Enable Phone Verification",
		"title_email": "Enable Email Verification",
		"title_google": "Enable Google Verification",
		"phone_open_success": "Phone verification enabled successfully",
		"email_open_success": "Email verification enabled successfully",
		"google_open_success": "Google verification enabled successfully"
	},
	"password_recovery": {
		"title": "Recover Login Password",
		"title1": "Reset Login Password",
		"title3": "Confirm Your Password",
		"tip3": "After changing the password, withdrawals will be prohibited for 24 hours.",
		"tip": "After changing the login password, withdrawals will be prohibited for 24 hours.",
		"tip1": "At least 8 characters including numbers and letters",
		"tip2": "Already a registered user?",
		"btn_login": "Login Now",
		"account": "Phone Number/Email",
		"account_placeholder": "Please enter phone number/email",
		"mes_code": "SMS Verification Code",
		"email_code": "Email Verification Code",
		"google_code": "Google Verification Code",
		"getCode": "Get Code",
		"code_placeholder": "Please enter verification code",
		"nextStep": "Next",
		"password": "Login Password",
		"update_password": "Change Password",
		"old_password": "Old Login Password",
		"new_password": "New Login Password",
		"confirm": "Confirm Password",
		"password_placeholder": "Please enter password",
		"submit": "Submit",
		"back": "Back",
		"success": "Password reset successfully"
	},
	"password_modify": {
		"title": "Change Login Password",
		"tip": "After changing the login password, withdrawals and OTC trading will be prohibited for 24 hours.",
		"old_password": "Current Login Password",
		"old_password_placeholder": "Please enter password",
		"new_password": "Please enter password",
		"new_password_placeholder": "Please enter new password",
		"password_confirm": "Confirm New Login Password",
		"password_confirm_placeholder": "Please enter password again",
		"mes_code": "SMS Verification Code",
		"email_code": "Email Verification Code",
		"google_code": "Google Verification Code",
		"google_placeholder": "Please enter Google verification code",
		"getCode": "Get Code",
		"code_placeholder": "Please enter verification code",
		"submit": "Submit",
		"forget": "Forgot Login Password",
		"success": "Login password changed successfully"
	},
	"set_trade_password": {
		"title": "Set Transaction Password",
		"password_input": "Please enter transaction password",
		"password_formatter": "At least 6 valid digits or letters",
		"password_confirm": "Confirm Password",
		"phone_num": "Phone Number",
		"mes_code": "SMS Verification Code",
		"email_code": "Email Verification Code",
		"code_placeholder": "Please enter verification code",
		"getCode": "Get Code",
		"submit": "Submit",
		"cancel": "Cancel",
		"success": "Transaction password set successfully",
		"bind_phone": "Please bind phone number first",
		"email_phone": "Please bind email first",
		"go_bind": "Go to Bind"
	},
	"modify_trade_password": {
		"title": "Change Transaction Password",
		"password_input": "Please enter transaction password",
		"new_password_input": "Please enter new transaction password",
		"password_formatter": "At least 6 valid digits or letters",
		"password_confirm": "Confirm Password",
		"mes_code": "SMS Verification Code",
		"email_code": "Email Verification Code",
		"google_code": "Google Verification Code",
		"code_placeholder": "Please enter verification code",
		"google_placeholder": "Please enter Google verification code",
		"getCode": "Get Code",
		"submit": "Submit",
		"cancel": "Cancel",
		"success": "Transaction password changed successfully"
	},
	"authentication": {
		"title": "Identity Verification",
		"country": "Nationality",
		"country_placeholder": "Please select your place of residence",
		"name": "Full Name",
		"name_placeholder": "Please enter full name",
		"IDType": "ID Type",
		"IDCard": "ID Card",
		"passport": "Passport",
		"ID": "ID Number",
		"idNum_placeholder": "",
		"submit": "Submit",
		"cancel": "Cancel",
		"tip": "· For the safety of your funds, identity verification is required before other operations.<br>· Once verified, information cannot be modified. Please fill in truthfully.<br>· After verification, you can perform withdrawals, fiat trading, and other operations.",
		"front": {
			"title": "Front photo of your ID card:",
			"con": "· Ensure the photo content is complete and clearly visible.<br>· Supports jpg/png/jpeg image formats.<br>· Image size cannot exceed 2M."
		},
		"back": {
			"title": "Back photo of your ID card:",
			"con": "· Ensure the photo content is complete and clearly visible.<br>· ID card must be within its validity period.<br>· Only supports jpg/png/jpeg image formats."
		},
		"hand": {
			"title": "Photo of you holding your ID:",
			"con": "· Please upload a photo of you holding the front of your ID and a personal signature.<br>· The personal signature must include a handwritten <label style=\"color: #F04C66\">date</label>.<br>· Only supports jpg/png/jpeg image formats."
		},
		"success": "Submitted successfully"
	},
	"trade_auth_setting": {
		"title": "Trade Verification",
		"tip": "After disabling, password verification will no longer be required when placing orders.",
		"open": "Always On",
		"close": "Permanently Off",
		"submit": "Submit",
		"cancel": "Cancel",
		"input_password": "Please enter transaction password",
		"success": "Modified successfully"
	},
	"email_bind": {
		"title": "Bind Email",
		"email": "Email",
		"email_placeholder": "Please enter email",
		"email_code": "Email Verification Code",
		"getCode": "Get Code",
		"code_placeholder": "Please enter verification code",
		"bind": "Bind",
		"back": "Back",
		"success": "Email bound successfully"
	},
	"googleBind": {
		"google_code": "Google Verification Code",
		"code_placeholder": "Please enter Google verification code"
	},
	"withdrawal_address_manage": {
		"title": "Withdrawal Address Management",
		"add_address": "How to add a withdrawal address?",
		"coin_type": "Currency",
		'network': "Network",
		"search_coin": "Search Currency",
		"another_name": "Address Alias",
		"another_name_placeholder": "Please enter address alias",
		"address": "Withdrawal Address",
		"address_placeholder": "Please enter or paste address",
		"memo_placeholder": "Please enter tag",
		"memo_tip": "If you are required to fill in an address tag (Destination Tag), numeric ID, or memo, please fill it in here; otherwise, it is not needed.",
		"add": "Add",
		"unbind": "Not Bound",
		"phone_code": "SMS Verification Code",
		"email_code": "Email Verification Code",
		"google_code": "Google Verification Code",
		"code_placeholder": "Please enter verification code",
		"get_code": "Get Code",
		"my_withdraw": "My Withdrawals",
		"operation": "Action",
		"withdraw": "Withdraw",
		"del": "Delete",
		"add_success": "Added successfully",
		"tip": "Tip",
		"delete_tip": "Are you sure you want to delete",
		"delete_btn": "Delete",
		"cancel": "Cancel",
		"delete_success": "Deleted successfully",
		"go_bind": "Go to Bind"
	},
	"receipt_money": {
		"title": "Payment Settings",
		"legal_tender": "Fiat Currency",
		"receiptType": "Payment Method",
		"bankcard": "Bank Card",
		"alipay": "Alipay",
		"wechat": "WeChat",
		"add": "Add",
		"news_title": "New Message Notifications <label style=\"color: #A0AAC1; font-size: 16px;\">(We will inform you of the latest progress of OTC orders via email or SMS.)</label>",
		"email_notice": "Email Notification",
		"phone_notice": "SMS Notification",
		"table_title": "My Payment Addresses <label style=\"color: #A0AAC1; font-size: 16px;\">(Only one account can be added per payment method.)</label>",
		"account": "Account",
		"name": "Name",
		"bank_info": "Bank Information",
		"operation": "Action",
		"edit": "Edit",
		"del": "Delete",
		"dialog_title": "Please fill in payment information",
		"deposit_bank": "Bank Name",
		"bank_address": "Bank Address",
		"optional": "Optional",
		"bankcard_num": "Bank Card Number",
		"confirm_num": "Confirm Card Number",
		"input_again": "Please enter again",
		"memo": "Remarks",
		"trans_password": "Transaction Password",
		"input_trans_password": "Please enter transaction password",
		"submit": "Confirm Information",
		"alipay_account": "Alipay Account",
		"upload_qr": "Upload QR Code",
		"wechat_account": "WeChat Account",
		"add_success": "Added successfully",
		"save": "Save",
		"edit_success": "Edited successfully",
		"tip": "Tip",
		"delete_tip": "Are you sure you want to delete",
		"delete_btn": "Delete",
		"cancel": "Cancel",
		"delete_success": "Deleted successfully",
		"needRealName": "Real-name verification required",
		"authentication": "Go to Verify"
	},
	"order_manage": {
		"ctc_order": "Spot Orders",
		"current_delegation": "Current Orders",
		"history_delegation": "Order History",
		"coin_type": "Currency",
		"all": "All",
		"all_direction": "All Directions",
		"time_start": "Start Time",
		"time_end": "End Time",
		"buy": "Buy",
		"sell": "Sell",
		"search": "Search",
		"delete_order": "Delete Invalid Orders",
		"time": "Time",
		"symbol": "Trading Pair",
		"way": "Type",
		"direction": "Direction",
		"limit": "Limit",
		"price": "Price",
		"amount": "Quantity",
		"total": "Order Total",
		"dk": "Point Card Used",
		"status": "Status",
		"had_cancel": "Canceled",
		"had_complete": "Completed",
		"deal_concluded": "Filled Quantity",
		"no_deal_concluded": "Unfilled",
		"operation": "Action",
		"order_id": "Order ID",
		"done_price": "Fill Price",
		"done_amount": "Fill Quantity",
		"fee": "Fee",
		"cancel": "Cancel",
		"detail": "Details",
		"delete_record": "Delete",
		"cancel_success": "Canceled successfully",
		"delete_success": "Deleted successfully"
	},
	"asset": {
		"overview": "Overview",
		"rwa_token": "RWA Token",
		"fund": "Fund",
		"estimated_total_assets": "Estimated Total Assets",
		"today_profit_loss": "Today's Profit/Loss",
		"recharge": "Recharge",
		"withdraw": "Withdraw",
		"records": "Records",
		"asset_account": "Asset Account",
		"asset": "Asset",
		"usd": "USD",
		"us_dollar": "USD",
		"hk_dollar": "HKD",
		"trade": "Trade",
		"no_data": "No Data",
		"can_not_recharge": "Recharge is not supported for this currency",
		"can_not_withdraw": "Withdrawal is not supported for this currency",
		"loaded_all": "All loaded",
		"mall_detail": "Mall Detail",
		"no_mall_detail": "No mall detail available",
		"available": "Available",
		"frozen": "Frozen",
		"market_trade": "Market Trade",
		"no_market_data": "No market data",
		"exchange_hkd_to_ht": "{coin} Coin can be purchased with {base}",
		"exchange_record": "{coin} Exchange Records>",
		"go_now": "Go Now"
	},
	"exchangeRecord": {
		"title": "{coin} Exchange Records",
		"detail_title": "{coin} Exchange Detail",
		"order_no": "Transaction No.",
		"transfer_amount": "Transfer Amount",
		"ht_amount": "Exchange Amount",
		"actual_transfer": "Actual Transfer",
		"actual_exchange": "Actual Exchange",
		"rate": "Exchange Rate",
		"recharge_time": "Recharge Time",
		"transfer_account_info": "Transfer Account",
		"transfer_serial": "Transfer Serial No.",
		"transfer_time": "Transfer Time",
		"review_time": "Review Time",
		"airdrop_time": "Airdrop Time",
		"reject_reason": "Reject Reason",
		"status": "Status",
		"status_completed": "Completed",
		"status_pending": "Pending",
		"status_rejected": "Rejected",
		"no_data": "No exchange records",
		"loaded_all": "All loaded~"
	},
	"exchangeHKD": {
		"title": "{coin} Exchange",
		"how_to_exchange": "How to Exchange HKD (e.g. HT)",
		"step1": "Step 1: HT Transfer",
		"step2": "Step 2: Approved to get HT",
		"step3": "Step 3: Sell HT for USD",
		"transfer_amount": "Transfer Amount",
		"input_amount_placeholder": "Enter amount, min 100 HKD",
		"ht_amount": "{coin} Amount",
		"rate": "Rate",
		"receipt_account": "Receiving Account",
		"account_number": "Account Number",
		"company": "Company",
		"bank": "Bank",
		"form_title": "To facilitate review, please provide your bank transfer information",
		"transfer_account": "Transfer Account",
		"transfer_name": "Transfer Name",
		"transfer_serial": "Transfer Serial No.",
		"input_placeholder": "Please enter",
		"tip1": "Please ensure the transfer amount matches the input amount. Inconsistent data will cause transfer failure.",
		"tip2": "After transfer, wait for review. Usually arrives within 24 hours.",
		"tip3": "For special cases, contact customer service with the recharge order number.",
		"tip4": "Your transferred HKD will be converted into corresponding assets according to the exchange rate and airdropped to your asset account.",
		"complete_transfer": "Complete Transfer",
		"copy_success": "Copy successful",
		"submit_fail": "Submit failed",
		"success_modal_title": "Important Notice",
		"success_modal_content": "After the transfer is completed, operations will complete the review as soon as possible. Once approved, it will be converted to corresponding assets at the exchange rate and airdropped to your asset account. Please check via: Assets - RWA Token.",
		"success_modal_btn": "Got it",
		"confirm_modal_title": "Confirm Submission",
		"confirm_modal_content": "Please make sure the transfer details are correct. Once submitted, it will be under review and cannot be changed. Confirm submission?",
		"confirm_modal_confirm": "Confirm",
		"confirm_modal_cancel": "Check Again",
		"min_amount_tip": "Minimum recharge 100 HKD",
		"input_transfer_account": "Enter transfer account",
		"input_transfer_name": "Enter transfer name"
	},
	"user_assets": {
		"bankAccountNumber": "Bank Account Number",
		"overview": "Asset Overview",
		"total_assets": "Total Account Assets (Equivalent)",
		"ctc_account": "Spot Account",
		"little_assets_hide": "Hide Small Assets",
		"member_card_title": "Member Packages",
		"my_card_title": "My Point Cards",
		"check_detail": "View Details",
		"search": "Search Currency",
		"coin_type": "Currency",
		"available_balance": "Available Balance",
		"freeze_balance": "Frozen Balance",
		"redeem": "Redeeming",
		"valuations": "Valuation",
		"operation": "Action",
		"recharge": "Deposit",
		"withdraw": "Withdraw",
		"validate_warning": "At least two verification methods need to be enabled. Please go to Personal Center to enable them.",
		"can_not_recharge": "Deposit function for this currency is temporarily closed",
		"can_not_withdraw": "Withdrawal function for this currency is temporarily closed",
		"record": "Transaction Records",
		"recharge_address": "Deposit Address",
		"blockchain_type": "Chain Type",
		"address_type": "Address Type",
		"new_address": "New Address",
		"old_address": "Old Address",
		"check": "View",
		"recharge_record": "Deposit Records",
		"copy_address": "Copy Address",
		"copy_memo": "Copy Memo",
		"copy_success": "Copied successfully",
		"copy_error": "Copy failed",
		"min_recharge": "Minimum deposit amount:",
		"recharge_warning": "Deposits less than the minimum amount will not be credited and cannot be refunded.",
		"memo_warning": "Must be filled in accurately",
		"tip_title": "Friendly Reminder:",
		"tip_con": "1. Do not deposit any non-ETH assets to the above address, otherwise the assets will be irrecoverable.<br>2. After you deposit to the above address, it requires X network confirmations to be credited.<br>3. Your deposit address will not change frequently and can be reused; if changed, we will try to notify you via website announcements or email.<br>4. Please ensure the security of your computer and browser to prevent information from being tampered with or leaked.",
		"choice_address": "Select Withdrawal Address",
		"choice_address_placeholder": "Please select withdrawal address",
		"withdraw_record": "Withdrawal Records",
		"add_address": "Add New Address",
		"withdraw_amount": "Withdrawal Amount",
		"available": "Available:",
		"withdraw_amount_placeholder": "Please enter withdrawal amount",
		"withdraw_amount_placeholder1": 'Minimum withdrawal amount is ',
		"withdraw_amount_placeholder2": 'Maximum does not exceed ',
		"min_withdraw": "Minimum withdrawal amount is",
		"withdraw_warning": "Deducted from balance first; if balance is insufficient, deducted from withdrawal amount.",
		"withdraw_success": "Withdrawal successful",
		"trans_password": "Transaction Password",
		"trans_password_placeholder": "Please enter transaction password",
		"buy_member": "You are about to purchase a member package. After purchase, you will enjoy member benefits. Please confirm your spot account balance is sufficient first.",
		"buy_amount": "Purchase Quantity",
		"should_pay": "Amount Payable",
		"pay_confirm_title": "Confirm Payment",
		"pay_confirm": "Confirm Payment",
		"pay_success": "Purchase successful",
		"available_not_enough": "Insufficient balance",
		"need_whole_number": "Input value must be a positive integer",
		"cancel": "Cancel",
		"phone_code": "SMS Verification Code",
		"phone_code_placeholder": "Please enter SMS verification code",
		"email_code": "Email Verification Code",
		"email_code_placeholder": "Please enter email verification code",
		"get_code": "Get Code",
		"phone_bind": "Bind Phone Number",
		"email_bind": "Bind Email",
		"google_code": "Google Verification Code",
		"google_code_placeholder": "Please enter Google verification code",
		"memo_tip": "· Incorrect or missing Memo may lead to asset loss. Please check carefully.<br><label class=\"font_color_red\">· Must be filled when transferring to an exchange address</label>",
		"memo_placeholder": "Please enter MEMO",
		"actual": "Actual credited amount:",
		"fee": "Fee:",
		"withdraw_btn": "Withdraw",
		"my_dk": "My Point Cards",
		"available_dk": "Point Card Balance",
		"buy_dk": "Buy Point Cards",
		"dk_desc": "Point Card is a trading fee prepaid card launched by the RWA platform. 1 Point Card (dk) = 1 USDT equivalent trading fee.",
		"buy_placeholder": "Please enter purchase quantity",
		"buy_btn": "Buy",
		"min_buy_amount": "Minimum purchase amount",
		"min_amount_warning": "Purchase amount cannot be less than the minimum amount",
		"available_usdt": "Available USDT",
		"api": {
			"tips_val_1": "Private keys allow you to access your account via the RWAEx open protocol API and execute trading instructions. The keys we provide are very important. Please keep them safe.",
			"setting": "API Settings",
			"check_document": "View API Documentation",
			"attentionVal1": "1. This platform provides powerful API services, including market data queries, trading, etc. Please refer to the API documentation. Merchant domain: openapi.rwa.ltd",
			"attentionVal2": "2. Each user can create up to 5 sets of API keys.",
			"attentionVal3": "3. Do not disclose your API keys to prevent financial losses. For security, we recommend binding IP addresses to your API keys.",
			"attentionVal4": "4. Each API key supports binding up to 5 IP addresses. Separate multiple IP addresses with commas.",
			"attention": "<label style=\"color: #F04C66\">Important Notes:</label><br>· We provide REST and WebSocket APIs. Please refer to the API documentation.<br>· Each user can create up to 10 pairs of API keys.<br>· For trading APIs, a single IP is limited to 1000 accesses per minute. Exceeding 1000 will lock the IP for 1 hour, automatically unlocking afterward.<br>· For trading APIs, a single API is limited to 60 accesses per second. Requests exceeding 60 per second will be considered invalid.<br>· K-line interface can only request data once per second.<br>· If you have any issues during use, please join QQ group 710574280 for authoritative answers.",
			"add": "Add New API",
			"fill_info": "Fill in API Key Information",
			"role_api": "API Key Permissions",
			"api_check": "Query Assets: Query account information and asset status",
			"api_trade": "Order Trading: Place, cancel, and query trading orders",
			"remarks": "Remarks",
			"remarks_placeholder": "API name remark",
			"bind_ip": "Bind IP Address (Optional)",
			"remark_placeholder": "API name remark",
			"bind_placeholder": "Multiple allowed, separated by ','",
			"create_key": "Create API Key",
			"my_key": "My API Keys",
			"id": "No.",
			"operation": "Action",
			"alert_title": "API Key",
			"show_once": "Only shown once. If forgotten, please regenerate.",
			"visit_key": "API Access Key",
			"private_key": "API Secret Key",
			"copy": "Copy",
			"important_info": "Important:<br>Secret keys allow you to access your account via the RWAEx open protocol API and execute trading instructions. The keys we provide are very important. Please keep them safe.",
			"confirm": "Confirm",
			"delete_api": "Delete",
			"delete_confirm": "Confirm Delete",
			"cancel": "Cancel",
			"delete_success": "Deleted successfully"
		},
		"web_record": {
			"tabTypeValue1": "RWA Tokens",
			"tabTypeValue2": "Funds",
			"membershipPackage": "Member Packages",
			"searchTitle": "Account",
			"info": 'Information',
			"transaction": "Transaction",
			"title": "Transaction Records",
			"recharge": "Deposit",
			"recharge2": "Top-up",
			"rechargeAddress": "Deposit Address",
			"rechargeTips": "When depositing, please carefully check the deposit information to avoid asset loss due to incorrect information.",
			"rechargeTips1": 'Please ensure the recharge amount is not less than',
			"rechargeTips2": 'not more than',
			"rechargeTips3": 'Avoid asset losses due to incorrect amounts',
			"withdraw": "Withdraw",
			"ctc": "Spot",
			"buy": "Buy",
			"fiatCurrency": "Fiat",
			"sell": "Sell",
			"other": "Other",
			"search": "Search Currency",
			"input_coin": "Enter currency",
			"time": "Time",
			"type": "Category - Currency",
			"amount": "Quantity",
			"status": "Status",
			"success": "Success",
			"fail": "Fail",
			"status_pending": "Pending",
			"complete": "Completed",
			"status_applied": "Applied",
			"status_checked": "Reviewed",
			"status_send": "Dispatched",
			"status_confirm": "Confirming",
			"status_withdraw": "Withdrawal Successful",
			"status_refused": "Rejected",
			"status_cancel": "Canceled",
			"recharge_address": "Deposit Address",
			"withdraw_address": "Withdrawal Address",
			"operation": "Action",
			"cancel": "Cancel",
			"cancel_success": "Canceled successfully",
			"check_detail": "View Details",
			"account_balance": "Account Balance",
			"wallet_handle_time": "Wallet Processing Time",
			"trade_id": "Transaction ID",
			"desc": "Description",
			"fee": "Fee",
			"dk": "Point Card Used",
			"rebate": "Rebate",
			"burst_block": "Block Burst",
			"block_detail": "Block Burst Details",
			"prize": "Prize Amount",
			"prize_order": "Winning Order Number",
			"prize_tip": "Congratulations on winning the Block Burst activity. The reward will be automatically deposited into your spot account within 24 hours. Please note the change in your account balance.",
			"block_detail_h2": "Dear user, congratulations on a successful block burst and sharing the Four-digit Prize Pool",
			"transfer": "Transfer",
			"mall": "Mall",
			"coin_type": "Coin Type",
			"flow_type": "Type",
			"all": "All",
			"mall_pay": "Mall Payment",
			"mall_distribute": "Mall Distribution",
			"completed": "Completed"
		}
	},
	"rechargeCoins": {
		"coin_type": "Coin Type",
		"chain_type": "Chain Type",
		"recharge_address": "Recharge Address",
		"notice": "Notice",
		"notice_content1": "Please ensure the chain type matches the withdrawal platform, otherwise assets may be lost",
		"notice_content2": "Please fill in the correct recharge address, incorrect address will cause assets to be unrecoverable",
		"copy_success": "Copy Success",
		"copy_fail": "Copy Failed"
	},
	"sellOrder": {
		"search_placeholder": "Search Order No.",
		"all": "All",
		"completed": "Completed",
		"pending_distribution": "Pending Distribution",
		"pending_payment": "Pending Payment",
		"cancelled": "Cancelled",
		"order_id": "Order No.",
		"subscription_shares": "Subscription Shares",
		"payment_price": "Payment Price",
		"total_payment": "Total Payment",
		"order_time": "Order Time",
		"cancel_order": "Cancel Order",
		"go_pay": "Go Pay",
		"load_complete": "All Loaded",
		"pay": "Pay",
		"pay_amount": "Pay Amount",
		"pay_method": "Payment Method",
		"balance": "Balance",
		"trade_password": "Trade Password",
		"password_placeholder": "Enter trade password",
		"confirm_pay": "Confirm Pay",
		"pay_success": "Payment Success",
		"confirm": "Confirm",
		"cancel_tip": "Tip",
		"cancel_confirm": "Confirm to cancel this order?",
		"cancel_success": "Cancel Success",
		"cancel_fail": "Cancel Failed",
		"pay_fail": "Payment Failed",
		"password_required": "Please enter trade password",
		"status_completed": "Completed",
		"status_pending_distribution": "Pending Distribution",
		"status_pending_payment": "Pending Payment",
		"status_cancelled": "Cancelled",
		"recharge": "Recharge",
		"set_password": "Set",
		"insufficient_balance": "Insufficient balance",
		"cancel": "Cancel"
	},
	"sellOrderDetails": {
		"payment_countdown": "Payment Countdown",
		"subscription_shares": "Subscription Shares",
		"subscription_amount": "Subscription Amount",
		"issue_price": "Issue Price",
		"total_payment": "Total Payment",
		"order_time": "Order Time",
		"distribution_time": "Distribution Time",
		"transaction_time": "Transaction Time",
		"order_no": "Order No.",
		"copy": "Copy",
		"asset_tip": "View My Assets",
		"cancel_order": "Cancel Order",
		"go_pay": "Go Pay",
		"back_to_order_list": "Back to Order List"
	},
	"withdrawCoins": {
		"coin_type": "Coin Type",
		"chain_type": "Chain Type",
		"address": "Withdraw Address",
		"withdraw_amount": "Withdraw Amount",
		"available": "Available Amount",
		"fee": "Fee",
		"notice": "Notice",
		"notice_content1": "Please ensure the chain type matches the deposit platform, otherwise assets may be lost",
		"notice_content2": "Please fill in the correct withdraw address, incorrect address will cause assets to be unrecoverable"
	},
	"confirmBuy": {
		"title": "Confirm Purchase",
		"subscription_shares": "Subscription Shares",
		"available": "Available Shares",
		"shares": "shares",
		"per_share": "share",
		"subscription_value": "Subscription Value",
		"issue_price": "Issue Price",
		"payment_total": "Payment Total",
		"payment": "Payment Method",
		"pay_from": "Pay from Asset Account",
		"balance": "Balance",
		"recharge": "Recharge",
		"cancel": "Cancel",
		"confirm_buy": "Confirm Purchase",
		"trade_password": "Enter Transaction Password",
		"confirm_pay": "Confirm Payment",
		"processing": "Processing...",
		"enter_password": "Please enter transaction password",
		"pay_fail": "Payment Failed",
		"order_create_fail": "Order Creation Failed",
		"pay_success": "Payment Successful",
		"tip": "Tip",
		"exceeded": "Exceeds Limit",
		"exceeded_tip": "Exceeds maximum purchase limit",
		"insufficient_balance": "Insufficient Balance",
		"unpaid_order_exists": "You have unpaid orders",
		"goto": "View"
	},
	"wallet": {
		"charging": {
			"amount": "Deposit Amount",
			"amount_placeholder": "Please enter deposit amount",
			"hkd_account": "Please transfer HKD to the following account",
			"receive_account": "Receiving Account",
			"company": "Account Opening Company",
			"bank": "Bank Name",
			"bank_info": "For verification purposes, please provide your bank card information for the transfer",
			"transfer_account": "Transfer Account",
			"name": "Transferor Name",
			"transaction_no": "Transaction Reference Number",
			"input_placeholder": "Please enter",
			"confirm_tip": "Please click Complete Transfer after the transfer is done",
			"complete": "Complete Transfer",
			"tip1": "Please ensure the received amount matches the entered amount. Mismatched data will cause deposit failure.",
			"tip2": "After the transfer is completed, wait for backend review. Usually arrives within 24 hours.",
			"tip3": "For special cases, please contact customer service with your deposit order number.",
			"amount_required": "Please enter deposit amount",
			"account_required": "Please enter transfer account",
			"name_required": "Please enter transferor name",
			"submit_success": "Transfer submitted. It will be credited after approval.",
			"submitted_title": "Submitted",
			"submitted_desc": "Transfer submitted. Please wait for approval. It will be credited after approval.",
			"view_records": "View Deposit Records"
		}
	},
	"burst": {
		"header": {
			"h1": "Block burst numbers drawn every night at 8:00 PM sharp.<br>If the last 7 digits of your order number match the block burst number, you win the big prize!",
			"h3": "RWA Exchange首创，爆块号码绝对公平公正 (RWA Exchange首创，block burst numbers absolutely fair and公正)",
			"four_digit": "Four-digit prize pool accumulated:",
			"seven_digit": "Seven-digit prize pool accumulated:",
			"nav1": "Current Public/Private Key Pair",
			"nav2": "Public/Private Key Relationship Verification",
			"nav3": "Click to view Block Burst Activity Rules"
		},
		"q1": {
			"title": "1. What is Block Burst?",
			"con": "This gameplay is首创 by RWA Exchange. RWA Exchange will allocate 30% of its fee revenue into the prize pool. If the last 4 or 7 Arabic digits of a user's spot trading order number match the last 4 or 7 digits of the current block burst number, the block burst is successful. The prize pool is shared according to the activity rules, and rewards are automatically distributed within 24 hours.",
			"table_title": "EOS Real-time Block Data",
			"time": "Block Time",
			"block_num": "Block Number",
			"hash": "Hash Value",
			"link": "Data provided by <a href=\"https://eospark.com/\" target=\"_blank\" style=\"color: #42CB83;\">eospark.com</a>"
		},
		"q2": {
			"title": "2. How to participate in Block Burst?",
			"con": "The total prize pool is 30% of RWA Exchange's fee revenue, with 20% allocated to the 7-digit pool and 10% to the 4-digit pool. Within 24 hours, user orders with a trading amount of at least 10 USDT in the spot trading area are eligible for the 'Block Burst' activity. Users matching the last 4 digits of the hash share the 4-digit pool funds, and users matching the last 7 digits share the 7-digit pool funds.",
			"trade_now": "Trade Now"
		},
		"q3": {
			"title": "3. How are rewards distributed?",
			"con": "Automatic draw daily at 20:00:00 (UTC+8). Prizes are distributed to users' spot accounts within 24 hours, and winning users are notified via SMS.",
			"table_title1": "Past Draw Information Publicity",
			"table_title2": "My Valid Orders",
			"time": "Date",
			"key": "Public/Private Key Pair",
			"hash": "Hash Value",
			"reward": "Draw Value",
			"publicKey": "Public Key",
			"privateKey": "Private Key",
			"orderNum": "Order Number",
			"status": "Status",
			"rewardMoney": "Prize Amount",
			"drawn_prize": "Won",
			"drawn_no_prize": "Not Won"
		},
		"alert": {
			"title_key": "Current Public/Private Key Pair",
			"publicKey": "Public Key",
			"privateKey": "Private Key",
			"not_yet_published": "Not yet published (will be published at 20:00:00)",
			"back": "Back",
			"title_rules": "Block Burst Activity Rules",
			"rules_con": "Select a pair of public/private keys. The public key is published daily at 08:00:00 (UTC+8).<br><br>The EOSIO mainnet produces two blocks per second. We take the two blocks generated at the exact 20:00:00 (UTC+8) that day. <label style=\"color: #A0AAC1\">The last 4 digits of the previous block and the last 7 digits of the latter block are added to the last 4 and last 7 digits of the private key, respectively, taking the last 4 and 7 digits of the final result. (Skip any letters. If the sum exceeds 4 or 7 digits, only take the last 4 or 7 digits.)</label><br><br>If a user's spot trading order number meets the 10 USDT trading volume and its last 4 or 7 digits match the block burst number, they share the prize pool奖金.<br><br><label style=\"color: #A0AAC1;\"> Example: Public key published at 08:00 on July 2, 2019:<br>EOS7wW1bAdMqVERBvFShcADXpLhTrs5oWSkzK7vkwosSvrqP5e2nq <br><br>Block hash values published at 20:00:<br>Previous: 03f9bf71d0e75e131fd75508091c0c64609a3ff9af71be496728e97ef<label style=\"color: #42CB83\">953</label>f<label><label style=\"color: #42CB83\">3</label>ba</label><br>Latter: 03f9bf727c3b3be0f9f6c36f8d1bebc0720fe2e65fd4d7f<label style=\"color: #42CB83\">0</label>e<label style=\"color: #42CB83\">88</label>cf<label style=\"color: #42CB83\">6</label>bf<label style=\"color: #42CB83\">21</label>d<label style=\"color: #42CB83\">4</label>eebb<br>Private key: 5JFyWm2Dx8ywKwEC2bvSUEnZE<label style=\"color: #42CB83\">1</label>rGSCPT<label style=\"color: #42CB83\">18</label>ijAwarJKrp<label style=\"color: #42CB83\">579</label>Qe<label style=\"color: #42CB83\">6</label>k<br><br>Draw values:<br>9533+5796=15329<br>0886214+1185796=2072010<br><br>If a user's order number ends with 5329 or 2072010, they meet the winning condition.</label><br><br><br>Draw Instructions:<br>Users should note that public/private key generation uses the RSA asymmetric encryption algorithm. The public key can be derived from the private key, but this derivation process is irreversible. Therefore, for every public key generated, there is a corresponding private key that cannot be changed.<br><br>The EOSIO mainnet produces two blocks per second. Block hash values are randomly generated and cannot be controlled manually.<br><br>Publishing the public key in advance means the private key cannot be changed; using hash values as the draw element means it cannot be manually controlled. This activity's draw is fair and公正, supporting user verification."
		}
	},
	"notification": {
		"system": {
			"nav": "System Notifications",
			"login_check": "Log in to view",
			"mark_all": "Mark All as Read",
			"mark_success": "Marked successfully"
		}
	},
	"partner": {
		h1Title1: "Join the RWA Membership Program",
		h1Title2: "Always-On Referral & Limited-Time Campaigns",
		spanVal: "How to Become a Member?",
		"spanVal01": "Register and log in to RWA.LTD",
		"spanVal02": "Use email to register and log in",
		"spanVal03": "Purchase a membership package to become a member",
		"spanVal04": "Pay 100USD/782HKD/100USDT",
		"spanVal05": "Get and share your invitation link",
		"spanVal06": "Invite your friends to register",
		"spanVal07": "Earn trading fee rebates",
		"spanVal08": "Earn rebates when your friend completes any trade",
		"becomeMember": "Become a Member",
		"memberTips": 'You are not a member yet. Purchase 100USD Points Card to become an exchange member and enjoy member benefits',
		"memberTips1": "Become a platform member now",
		"memberTips2": "Invite more friends to earn more rewards",
		"memberTips3": "Invite more friends to earn more rewards",
		"memberTips4": "You are about to purchase a member package. After purchase, you will enjoy member benefits. Please confirm your spot account balance is sufficient first.",
		"memberTips5": "RWA.LTD Member Packages",
		"memberTips6": "Become an exchange member, win 40% trading fee rebate rewards",
		"memberTips7": "Congratulations on becoming a member",
		"memberTips8": "Invite friends now to earn trading fee rebates!",
		"memberTips9": 'You have become a member of the platform',
		"dk_balance": "DK Balance: ",
		"dk_detail_title": "DK Details",
		"dk_type": "Type",
		"dk_type_fee": "Fee Deduction",
		"dk_type_buy": "Member Package Purchase",
		"memberWorth": "Value",
		"memberPay": "Payment Required",
		"memberNowPay": "Pay Now",
		"memberVip": "Level",
		"shareList": "Invitation Data",
		"shareListTips": 'Rewards for inviting friends to activate membership are issued in real time and directly credited to your USD asset wallet. Please check and receive them.',
		"rebateRatio": "Rebate Ratio",
		"cumulativeRebate": "Total Rebates",
		"cumulativeCashback": "Total Cashback",
		"cumulativeCashback1": "Total Invitations (Direct)",
		"shareTab1": "Invitation Ranking",
		"shareTab2": "Invitation Records",
		"shareTab3": "Rebate Records",
		"questionsTitle": "FAQ",
		questionsVal1: 'Is there a cap on referral rebates?',
		questionsVal2: 'Yes. For compliance reasons, RWA.LTD has set a monthly upper limit of 1000USD on the total amount of referral rebates and cashbacks for each member.',
		questionsVal3: 'How to get referral rebates after becoming a member?',
		questionsVal4: 'Member A invites friend B to register on the exchange. When B trades on the exchange, A can get a 40% rebate on trading fees. If B further invites C to register, when C trades, B can get a 40% rebate on trading fees, and A can get a 10% rebate on trading fees at the same time.',
		questionsVal5: 'How to get trading cashbacks after becoming a member?',
		questionsVal6: 'If friend B invited by A becomes an exchange member, A can get a cashback of 20USD/USDT. If B further invites C to become an exchange member, B can get a cashback of 20USD/USDT, and A can get a cashback of 10USD/USDT.',
		questionsVal61: 'Is there a time limit for the referral program?',
		questionsVal62: 'Is there a time limit for the RWA Membership \
						Program? Up to now, there is no time limit set for this Program. \
						However, RWA.LTD reserves the right to modify, suspend or \
						terminate the Program at any time at its sole discretion without \
						prior notice.',
		questionsVal7: 'What benefits can be enjoyed after becoming a member?',
		questionsVal8: 'After becoming a member, you will be entitled to the following benefits:',
		questionsVal81: '1. Referral Cashback: You can get cashback rewards after your downline friends purchase the membership package.',
		questionsVal82: '2. Trading Fee Discount: Enjoy a 50% discount on platform trading fees for 365 days from the date of purchase.',
		questionsVal83: '3. The 100USD membership fee can deduct 50% of the trading fees. During the deduction period, as members enjoy a 50% discount on trading fees, the additional trading fees to be paid are only 25% of the original fee.',
		"header_con1": "Share Platform Benefits with Users",
		"header_con2": "Millionaire Partner Program",
		"header_con3": "Member Recruitment Ongoing",
		"not_login": "You are not logged in",
		"please_login": "Please log in first",
		"need_set_password": "Need to set transaction password",
		"set_now": "Go to set",
		"not_yet_member": "You are not yet a member",
		"not_yet_partner": "You are not yet a partner",
		"update_now": "Upgrade Now",
		"is_vip": "Hello, your current level is",
		"my_reward": "My Earnings (Equivalent USDT)",
		"rwa_register": "Registered User",
		"rwa_member": "RWA Member",
		"rwa_partner": "RWA Partner",
		"rwa_diamond": "RWA Diamond Partner",
		"create_poster": "Generate Poster",
		"my_invite_code": "My Invitation Code",
		"share_invite_code": "Share Invitation Link",
		"my_invite_code_url": "My Invitation Code Link",
		"copy_success": "Copied successfully",
		"copy_fail": "Copy failed",
		"invite_reward_withdraw": "Point Card Cashback",
		"second_invite_reward_withdraw": "Second-level Point Card Cashback",
		"invite_reward_fee": "Trading Fee Rebate Ratio",
		"second_invite_reward_fee": "Second-level Trading Fee Rebate Ratio",
		"invite_amount": "Number of Invitations",
		"invite_up_member": "My First-level Members",
		"invite_upup_member": "My Second-level Members",
		"volume_24h": "24H Trade Count",
		"reward_withdraw_24h": "24H Rebates Issued",
		"reward_fee_total": "My Trading Fee Rebates",
		"reward_withdraw_total": "My Invitation Cashback",
		"reward_cash_total": "Cashback Amount",
		"title1": "1. What is a membership-based exchange?",
		"table_title1": "RWA Exchange Member Benefits & Rebate Rules",
		"table_title2": "RWA Exchange Membership Level Requirements",
		"dk_reward": "Point Card Cashback",
		"trans_reward_fee": "Trading Fee Rebate",
		"up_trans_reward_fee": "Second-level Trading Fee Rebate",
		"level": "Level",
		"up_dk_reward": "Second-level Point Card Cashback",
		"fee_discount": "Fee Discount",
		"need": "Required",
		"no_need": "Not Required",
		"real_name": "Real-name Verification",
		"buy_dk": "Purchase Point Cards",
		"need_invite_amount": "Invitation Requirement",
		"need_trans_money": "Trading Volume Requirement",
		"con1": "Members of RWA Exchange can enjoy many platform benefits. The platform's定位 is as an exchange technology service provider, transferring exchange profits to members, allowing members to enjoy more收益, becoming the 'owners' of the exchange.<br>RWA platform attracts优质 users to join the community through the membership system, adopting community co-construction and member-benefit sharing to build a strong RWA community, further building the world's #1 membership-based exchange.",
		"example1": "Example:<br><p style=\"color: #222A55; font-size: 16px;\">1) A is a registered user of RWA Exchange. How does A become an exchange member?</p>A can become an exchange member simply by directly purchasing 100 USDT worth of point cards.<p style=\"margin-top: 30px;color: #222A55; font-size: 16px;\">2) After becoming a member, how does A get invitation rebates?</p>A invites friend B to register on RWA Exchange. When B trades on the exchange, A receives a 40% rebate on the trading fees.<br>B then invites C to register. When C trades, B receives a 40% trading fee rebate, and A receives a 10% trading fee rebate.<p style=\"margin-top: 30px;color: #222A55; font-size: 16px;\">3) After becoming a member, how does A get trading cashback?</p>If friend B invited by A also becomes an exchange member, A receives a 20 USDT cashback.<br>If C invited by B also becomes an exchange member, then B receives a 20 USDT cashback, and A receives a 10 USDT cashback.",
		"title2": "2. How to become an exchange member and a higher-level partner?",
		"con2": "After a user purchases 100 USDT worth of point cards to become a RWA platform member, they can automatically upgrade to a higher-level partner upon meeting both the invited member count requirement and the trading volume requirement.",
		"example2": "Example:<br><p style=\"color: #222A55; font-size: 16px;\">1) A is already an exchange member. How to upgrade to become a partner?</p>A must directly invite at least 2 members (including member status or above) and have a total trading volume of at least 10000 USDT (including Taker and Maker) on the RWA platform to become a RWA Partner.<br>A must directly invite at least 5 members (including member status or above) and have a total trading volume of at least 50000 USDT (including Taker and Maker) on the RWA platform to become a RWA Diamond Partner.<p style=\"margin-top: 30px\">A member refers to a user who has purchased 100 USDT worth of point cards.</p>",
		"example2_2": "<p style=\"color: #222A55; font-size: 16px;\">2) I am already a member. Can I purchase member权益 to gift to others?</p>When you are already a member, you can purchase member权益 to generate a designated member invitation code to help others register as a member in one step.<br>When the other party successfully registers using your member权益 invitation code, they become a member immediately without going through other steps.<br>Each member权益 invitation code can only be used once and becomes invalid upon successful registration.",
		"btn_be_member": "Become an Exchange Member Now",
		"btn_detail": "Member Benefits Details",
		"btn_gift": "Purchase Member权益 Card to Gift to Others",
		"btn_check": "Check Member权益 Card Usage",
		"title3": "3. How are rebates distributed?",
		"con3": "Daily at 08:00:00 (GMT+0800), referral rewards from the previous 24 hours will be refunded and directly deposited into your spot account. Please check your balance.",
		"reward_cash_rank": "Cashback Ranking",
		"invite_record": "My Invitation Records",
		"reward_record": "My Rebate Records",
		"rank": "Rank",
		"partner_lvl": "Partner Level",
		"user": "User",
		"time": "Time",
		"user_invited": "Invitee",
		"reward_cash_amount": "Cashback Amount",
		"reward_fee_money": "Rebate Amount",
		"btn_alert": "Start My Privilege Journey",
		"buy_card": "Purchase Member权益 Card",
		"pay_after": "Invitation code displayed after payment",
		"create_invite_code": "Generate Invitation Code",
		"assign_user": "Assign User",
		"pay_con": "You are about to purchase a member权益 card. After purchase, you can gift it to others. Please confirm your spot account balance is sufficient first.",
		"should_pay": "Amount Payable",
		"trade_password_placeholder": "Please enter transaction password",
		"uid_placeholder": "Please enter user UID",
		"uid_error": "Invalid UID",
		"check": "Verify",
		"not_check": "Please perform identity verification first",
		"check_fail": "UID verification failed, cannot purchase membership for this user",
		"is_follow_me": "This user is your directly invited user",
		"not_follow_me": "This user is not your directly invited user. Please purchase cautiously.",
		"pay_confirm": "Confirm Payment",
		"be_member": "Already a member",
		"cancel": "Cancel",
		"buy_complete": "Purchase Complete",
		"click_copy": "Click to Copy",
		"success_con": "When someone registers using your invitation code, they become a member immediately. Each invitation code can only be used once and becomes invalid upon successful registration.",
		"close": "Close",
		"has_buy_card": "Purchased权益 Cards",
		"buy_time": "Purchase Time",
		"invite_code": "Invitation Code",
		"direct": "Direct Upgrade",
		"status": "Status",
		"status_0": "Not Verified",
		"status_1": "Verified",
		"status_2": "Under Review",
		"status_3": "Review Failed",
		"code_user": "User",
		"operation": "Action",
		"copy": "Copy",
		"not_use": "Not Used",
		"invalid": "Invalid",
		"must_member": "Only members can purchase权益 cards",
		activity: {
			title: "The RWA Membership Program",
			content1: "Ongoing Benefits",
			content2: "1. Trading Fee Rebate: Member A (the “Referrer”) invites Member B (the \
						“Referee”) to register on RWA.LTD. When Member B conducts trades, \
						Member A is entitled to a 40% rebate on B’s trading fees. If Member B \
						further invites Member C, then: ",
			content2$1: " - Member B is entitled to a 40% rebate on C’s trading fees; ",
			content2$2: " - Member A is entitled to a 10% rebate on C’s trading fees.", 
			
			content2$2$0: "2. Referral Bonus: After Member A successfully refers Member B to \
						register on RWA.LTD, Member A will receive a registration bonus of \
						USD 20 (or equivalent in USDT). If Member B further refers Member \
						C, then:",
			content2$2$1: " - Member B will receive a registration bonus of USD 20 (or equivalent in USDT);",
			content2$2$2: " - Member A will receive a second-tier referral bonus of USD 10(or equivalent in USDT).",
				
			content3: "Limited-Time Benefits",
			content3$0: "1. Airdrop Package: USD 100 Worth of Premium Consumer Asset \
						Tokens [Campaign Period: March 19, 2026 – April 19, 2026]",
			content3$1:	" - Airdrop Contents: 150 RWA + 300 DIMD + 300 GCT + 300 TOP100 ",
			content3$2:	" - Distribution Rules: Member data will be calculated every Sunday, and asset packages will be distributed sequentially. All assets will be fully distributed within three (3) months.",
			
			content3$2$0: "2. 50% Trading Fee Discount [Validity: 1 Year]",
			content3$2$1: " - Trading Fee Discount: Members enjoy a 50% discount on \
							trading fees across all trading pairs for one (1) year — the \
							more you trade, the more you save.",
			content3$2$2: "- Membership Fee Offset Mechanism: The paid membership fee \
							of USD 100 may be used to offset up to 50% of trading fees. \
							During the offset period, combined with the 50% trading fee \
							discount, the effective trading fee paid by members is only \
							25% of the original fee. ",
					
			content4: "March 19, 2026 to March 20, 2026",
			content5: "3. Campaign Benefits",
			content6: "Benefit 1: Airdrop of Platform Premium Asset Gift Pack Worth 100USD",
			content7: "New members who activate their membership during the campaign will receive an additional premium consumer RWA asset portfolio gift pack with a total value of 100USD.",
			content8: "Airdrop Content: 150 RWA + 300 DIMD + 300 GCT + 300 TOP100",
			content9: "Distribution Rules: Member data will be counted every Sunday, and one asset gift pack will be airdropped in turn. All asset gift packs will be fully distributed within 3 months.",
			content10: "Benefit 2: Exclusive Annual Member Benefits",
			content11: "50% Trading Fee Discount: Enjoy a 50% discount on trading fees for all trading pairs within 1 year — the more you trade, the more you save.",
			content12: "Membership Fee Deduction for Trading Fees: The 100USD membership fee you paid can be directly used to deduct 50% of any future trading fees incurred, which is equivalent to an additional 50% discount on top of the original 50% trading fee discount.",
			content13: "Benefit 3: Refer Friends & Get Instant Cashback",
			content14: "Direct Referral Reward: Get an instant 20USD/USDT cashback when you directly invite friends to activate their membership.",
			content15: "Indirect Referral Reward: Get an additional 10USD/USDT cashback when your referred friends invite new members."
		}
	},
	"about": {
		"title": 'About Us',
		titleInfo: 'RWA.LTD is the world’s first trading platform dedicated to Non-Financial Real World Assets (RWA) tokens, built by the Hong Kong International New Economy Research Institute (INERI) through its wholly-owned subsidiary RWAGroup Limited. It operates in compliance with Hong Kong law as a trading platform for "Limited Purpose Digital Tokens".',
		titleInfo1: 'Founded in 2019 by CEO Mr. Fu Rao, the Hong Kong International New Economy Research Institute (INERI) is one of the incubated enterprises of Hong Kong Science and Technology Parks and receives multiple subsidies from the Government of the Hong Kong Special Administrative Region. In its early days, INERI’s core business was blockchain-empowered industrial consulting. Mr. Fu Rao has also long been involved in university teaching and research, and has served as a visiting lecturer at the University of Hong Kong, City University of Hong Kong, The Chinese University of Hong Kong (Shenzhen) and Peking University. Since 2023, INERI has focused on the layout of tokenization applications for non-financial RWAs. The NFT China platform founded by INERI has collaborated with well-known enterprises such as BYD (BYDDY) to lead and promote the issuance of a number of non-financial NFT projects, with the platform gaining over 300,000 registered users within three months of its launch.',
		titleInfo2: 'Based on its rich operational experience in NFT platforms and industrial resources, INERI initiated the preparation of a non-financial Fungible Token (FT) platform at the end of 2024. The RWALTD platform was officially launched in mid-September 2025, becoming the world’s first platform dedicated to the trading of Limited Purpose Digital Tokens. It is committed to realizing the digital expression and circulation of non-financial rights and interests through blockchain technology. In March 2026, RWA.LTD completed its first platform upgrade and system revision, further enhancing the platform’s security, stability and user experience, and continuously promoting the development of the non-financial RWA tokenization ecosystem.'
	},
	"footerAddress": {
		"btnVal1": "Search",
		"btnVal2": "Clear",
		"btnVal3": "Phone",
		"inputPlaceholder": "Please enter location name"
	},
	"download": {
		"title": "RWA App Download",
		"title1": "Chain Commerce Platform Grand Launch",
		"title2": "Innovative combination of token mechanism and commodity economy, bringing you a brand new experience",
		"h3": "Secure, Stable, Efficient",
		"h1": "Digital Asset Trading Platform",
		"ios": "IOS Download",
		"android": "Android Download"
	},
	"financial": {
		"home": {
			"header": "RWAEx Financial Treasure",
			"tip": "is a blockchain asset interest-earning, stable收益 investment platform, including定期 (locked理财), 活期理财, and other product types, providing the best investment channel for稳健型 investment users",
			"my_had": "My Holdings",
			"ongoing": "Ongoing",
			"mining": "Mining",
			"tobe_started": "Starting Soon",
			"end": "Ended",
			"rate_year": "Reference Annualized Rate",
			"auto": "Flexible",
			"buy_min": "Min. Purchase",
			"mine_min": "Min. to Mine",
			"assign_coin": "Interest Currency",
			"to_end_time": "Time until抢购 ends",
			"left_position": "Remaining Position",
			"lock_position": "Locked Position",
			"day": "d",
			"hour": "h",
			"minutes": "m",
			"seconds": "s",
			"after_start": " until start"
		}
	},

	"footerPrivacy": {
		"title": "Privacy Statement",
		"titleInfo": "This Privacy Statement is issued by RWA Group (hereinafter referred to as \"we\", \"us\", or \"our\"; \"RWA Group's\" shall be construed accordingly) to you as a visitor or user of this platform [RWA.LTD], the website [https://www.rwahk.ltd/], and any related computer or mobile applications. RWA Group refers to RWA Group Limited (a company incorporated in Hong Kong with limited liability, Business Registration Number 74645397). This Statement is made pursuant to the Personal Data (Privacy) Ordinance (\"the Ordinance\").",
		"titleInfo1": "Part 1: Personal Information Collection Statement (PICS)",
		"titleInfo2": "A. Purposes of Collection",
		"titleInfo3": "We collect and store your personal data to provide and optimize our services, including but not limited to:",
		"titleInfo4": "(a) Creating and managing your user account;",
		"titleInfo5": "(b) Verifying your identity in compliance with Anti-Money Laundering (AML) and Counter-Financing of Terrorism (CFT) requirements;",
		"titleInfo6": "(c) Processing your transactions (including deposits, withdrawals, and trading);",
		"titleInfo7": "(d) Sending administrative notices and (where permitted) marketing information;",
		"titleInfo8": "(e) Complying with applicable legal obligations or regulatory requirements.",
		"titleInfo9": "B. Categories of Personal Data Collected",
		"titleInfo10": "The personal data we may collect includes:",
		"titleInfo11": "(a) Identification data (e.g., name, Hong Kong Identity Card/Passport number);",
		"titleInfo12": "(b) Contact information (e.g., email address, phone number, residential address);",
		"titleInfo13": "(c) Financial and transaction details (e.g., wallet addresses, transaction records, bank account information);",
		"titleInfo14": "(d) Device and usage data (e.g., IP address, browser type, Cookies).",
		"titleInfo15": "C. Consequences of Failure to Provide Data",
		"titleInfo16": "The provision of personal data is generally voluntary. However, certain data is necessary for using our services. If you fail to provide such data, we may be unable to provide you with products or services, including but not limited to:",
		"titleInfo17": "(a) Opening or maintaining your account;",
		"titleInfo18": "(b) Processing your transactions;",
		"titleInfo19": "(c) Complying with legal or regulatory requirements.",
		"titleInfo20": "D. Classes of Persons to Whom Data may be Disclosed",
		"titleInfo21": "We may disclose your personal data to the following classes of persons:",
		"titleInfo22": "(a) Our affiliated companies and service providers (e.g., KYC service providers, payment processing institutions);",
		"titleInfo23": "(b) Government authorities, regulatory agencies or law enforcement agencies as required by law;",
		"titleInfo24": "(c) Legal, financial or professional advisors subject to a duty of confidentiality.",
		"titleInfo25": "E. Direct Marketing",
		"titleInfo26": "We may use your name, mobile phone number, email address and residential address to send you marketing communications regarding our services and products. We will not use your personal data for direct marketing purposes unless we have obtained your consent or you have not objected. You may opt-out of receiving marketing communications at any time by contacting us via [s@rwa.ltd].",
		"titleInfo27": "F. Right of Access and Correction",
		"titleInfo28": "You have the right to request access to and correction of your personal data held by us in accordance with the Ordinance. Requests should be submitted in writing to [s@rwa.ltd].",
		"titleInfo29": "Part 2: Privacy Policy Statement (PPS)",
		"titleInfo30": "A. Types of Personal Data Held",
		"titleInfo31": "The types of personal data we hold include:",
		"titleInfo32": "(a) User registration and identification information;",
		"titleInfo33": "(b) Transaction and activity records;",
		"titleInfo34": "(c) Communications with users;",
		"titleInfo35": "(d) Cookies and technical usage data.",
		"titleInfo36": "B. Main Purposes of Use",
		"titleInfo37": "The purposes of using personal data are the same as those stated in the PICS above.",
		"titleInfo38": "C. Data Retention",
		"titleInfo39": "We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected or as required by law (e.g., AML/CFT requirements). After the relevant retention period expires, the data will be securely deleted or anonymized. Notwithstanding the foregoing, you have agreed in the Platform Use Agreement that we may retain certain information for up to six (6) years.",
		"titleInfo40": "D. Security Measures",
		"titleInfo41": "We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, processing, deletion or loss.",
		"titleInfo42": "E. Access and Correction of Data",
		"titleInfo43": "This section is the same as stated in the PICS above.",
		"titleInfo44": "F. Use of Cookies",
		"titleInfo45": "We may use cookies or similar technologies to enhance user experience and analyze website traffic. You may disable cookies through your browser settings, but this may affect the proper functioning of certain features.",
		"titleInfo46": "Last Updated: [2025/08/08]",
		"titleInfo47": "Contact: [s@rwa.ltd]"
	},
	"footerAgreement": {
		"title": "Platform Use Agreement",
		"titleTime": "Last Updated: August 28, 2025",
		"titleInfo1": "If you do not fully understand and accept the following, you should not purchase, hold, consume or transfer platform circulating tokens.",
		"titleInfo2": "This Platform Use Agreement (hereinafter referred to as this \"Agreement\") constitutes a legally binding agreement between you and RWA Group (hereinafter referred to as \"we\", \"us\", or \"our\"). RWA Group includes RWA Group Limited (a company incorporated in Hong Kong with limited liability; Business Registration Number 74645397), any of its affiliated entities, all employees, external service contractors and external advisors of the foregoing entities. This Agreement applies to the legal relationship between you and us, including but not limited to the legal relationship arising from your",
		"titleInfo3": "purchase, holding, consumption or transfer of any tokens circulating on the platform RWA.LTD, the website [https://rwa.ltd] and other related computer or mobile applications",
		"titleInfo4": "(collectively referred to as the \"Platform\") (hereinafter referred to as \"Platform Circulating Tokens\"). By accessing or using the Platform, registering a Platform account, purchasing, holding, consuming or transferring Platform Circulating Tokens, or engaging in other Platform-related or Platform-based activities (collectively referred to as \"Platform Activities\" or \"Activities\"), you acknowledge and agree that you will comply with this Agreement. If you engage in Platform Activities with respect to any Platform Circulating Token, you acknowledge and agree that you will comply with the agreement specifically formulated for the goods or services represented by that token, which may be presented on the Platform in various forms, including but not limited to the token white paper (hereinafter referred to as the \"Product Agreement\"). You further acknowledge and agree that, based on commercial reasonableness, we may unilaterally, from time to time and without specific prior notice, update or modify all of the aforementioned agreements, and you should read and understand the latest versions of these agreements and any supplementary documents referenced therein before engaging in any Platform Activities.",
		"titleInfo5": "Risk Warning and Acknowledgement",
		"titleInfo6": "For the avoidance of doubt, this Risk Warning section is an integral part of this Agreement and has the same legal effect as other parts. Before making any decisions related to Platform Circulating Tokens or conducting any transactions, you should take all reasonable measures to ensure you fully understand such transactions and independently assess their suitability and risks. Before making any decisions related to Platform Circulating Tokens, you should ensure you have sufficient information. If you have any questions about Platform Circulating Tokens, Platform Activities or any content of this Agreement, you should obtain independent professional advice. RWA Group has determined that Platform Circulating Tokens are \"Digital Tokens of Limited Use\" as defined in Section 53ZR of the Hong Kong Anti-Money Laundering and Counter-Terrorist Financing Ordinance (\"AMLO\"), i.e., customer reward or bonus points; in-game assets; or any digital form of value that (i) is similar to customer reward or bonus points or in-game assets; and (ii) according to the issuer's intention, cannot be converted into money or another generally accepted transaction medium. Therefore, pursuant to Section 53ZRA of AMLO, Platform Circulating Tokens are not \"virtual assets,\" \"VA\" or \"VirtualAsset\" under AMLO. Platform Circulating Tokens are not structured or sold as securities or any other form of investment product. Platform Circulating Tokens have not been reviewed, filed or authorized by any regulatory authority. RWA Group is not, and does not intend to, conduct any activities related to Platform Circulating Tokens in any jurisdiction where such activities are prohibited by relevant laws. You should ensure that all activities related to Platform Circulating Tokens are lawful in your applicable jurisdiction.",
		"titleInfo7": "You hereby acknowledge that you understand and assume various risks (including but not limited to the following risks) and all losses resulting from these risks:",
		"titleInfo8": "A. Risks Related to Blockchain Technology and Cybersecurity",
		"titleInfo9": "As Platform Circulating Tokens are based on blockchain technology, any failure, crash or abandonment of any related blockchain may have a material adverse effect on Platform Circulating Tokens. In addition, technological advancements such as advances in cryptography or quantum computing may pose risks to Platform Circulating Tokens by potentially rendering the cryptographic consensus mechanism of the underlying blockchain ineffective. Like other decentralized crypto tokens based on blockchain technology, Platform Circulating Tokens are susceptible to attacks on nodes or validators responsible for verifying/confirming transactions of Platform Circulating Tokens on the relevant blockchain. Any successful attack could pose risks to Platform Circulating Tokens. Hackers or other malicious groups or organizations may attempt to interfere with Platform Circulating Tokens in various ways, including but not limited to malware attacks, denial of service attacks, consensus attacks, Sybil attacks, masquerading attacks and spoofing attacks.",
		"titleInfo10": "B. Risks Related to Insufficient Liquidity of Platform Circulating Tokens",
		"titleInfo11": "There is no established market for Platform Circulating Tokens, and the sale of Platform Circulating Tokens may not result in an active or liquid market. Holders may face liquidity risks regarding Platform Circulating Tokens. RWA Group is not responsible for the circulation and trading of Platform Circulating Tokens on any market. No entity is obligated to purchase Platform Circulating Tokens from any holder, and no entity guarantees the liquidity or market price of Platform Circulating Tokens. RWA Group therefore cannot ensure there will be any demand or market for Platform Circulating Tokens. RWA Group has the right to adjust, limit or suspend the liquidity and any other activities of Platform Circulating Tokens based on various considerations (e.g., changes in laws, policies or enforcement, etc.), and shall not be liable for such adjustments, limitations or suspensions.",
		"titleInfo12": "C. Risks Related to Price Volatility",
		"titleInfo13": "The price of Platform Circulating Tokens may generally fluctuate relatively due to external factors such as the market for specific underlying assets (e.g., related intellectual property, products or services, etc.) and may experience significant volatility in the short term. A decline in the price of a single representative blockchain asset may lead to a lack of confidence in the blockchain industry; even if such asset is unrelated to Platform Circulating Tokens, its price decline may cause a loss of confidence in the entire blockchain industry, thereby affecting the market for Platform Circulating Tokens. The real-time price of Platform Circulating Tokens trading is subject to material risk and may fluctuate significantly due to market conditions and other factors beyond RWA Group's control.",
		"titleInfo14": "D. Risks Related to Uncertain Regulatory Restrictions",
		"titleInfo15": "Unless otherwise specifically stated by the Platform, Platform Circulating Tokens are not listed on any licensed virtual asset trading platform under Hong Kong AMLO, and there is no guarantee that they will be listed on such platforms in the future. Importantly, although Platform Circulating Tokens are designed and structured as \"digital tokens of limited use\" or usufruct tokens with no investment attributes whatsoever, and never as \"virtual assets\" as defined in Section 53ZRA of AMLO or as securities or other investment products, RWA Group has the sole discretion to adjust, limit or suspend any activities related to Platform Circulating Tokens due to changes in legal rules, enforcement attitudes or circumstances, or for other reasons beyond RWA Group's control, and RWA Group shall not bear any compensation liability for such actions. If you intend to take any action (directly or indirectly) regarding Platform Circulating Tokens, you are responsible for complying with all applicable laws, regulations and rules, and providing all appropriate risk warnings and disclosures.",
		"titleInfo16": "E. Unforeseeable Risks",
		"titleInfo17": "Cryptographic tokens like Platform Circulating Tokens are new and untested technologies. In addition to the risks described above, purchasing, holding, consuming, transferring and other activities involving Platform Circulating Tokens may involve other risks that RWA Group cannot foresee or reasonably control. These risks may manifest in unforeseeable ways or combinations.",
		"titleInfo18": "F. Risks of Platform Policy Changes",
		"titleInfo19": "RWA Group reserves the right to change the nature and content of Platform Circulating Tokens, Platform Activities, this Agreement and any Product Agreements (including but not limited to their supply and distribution plans, policies and mechanisms, etc.) at any time based on (i) what it considers legitimate business considerations, (ii) its understanding of current laws and policies, or (iii) its understanding of legal and policy trends. Before making any decisions related to Platform Circulating Tokens, you should ensure that you have carefully read and fully understood the latest version of this Agreement and other updated relevant content on the Platform at that time.",
		"titleInfo20": "1. Accounts.",
		"titleInfo21": "1.1 Registration.",
		"titleInfo22": "You need to register an account on the Platform to be entitled to any rights under this Agreement. However, failure to register or log in to an account shall not affect this Agreement being a valid agreement binding on you and us under applicable law. By opening an account, you agree to use the account solely for yourself. Any use of your account by a third party requires our written consent. You are fully responsible for all activities conducted through your account and the legal consequences arising therefrom.",
		"titleInfo23": "1.2 Restrictive Measures.",
		"titleInfo24": "The Platform has the right to unilaterally take restrictive measures such as account freezing, transaction restrictions and/or asset locking in the following circumstances without prior notice to users:",
		"titleInfo25": "a. Upon instruction from judicial authorities, regulatory agencies or other competent authorities;",
		"titleInfo26": "b. Discovery or reasonable suspicion of abnormal transactions, suspected money laundering, fraud, illegal fundraising, market manipulation, cyber attacks or other illegal activities in the account;",
		"titleInfo27": "c. Discovery or reasonable suspicion that the account violates this Agreement or other Platform rules; or",
		"titleInfo28": "d. The Platform reasonably believes it is necessary to take any restrictive measures on certain accounts to protect other users, the Platform or the public interest.",
		"titleInfo29": "After taking freezing measures, users may submit materials as required by the Platform to apply for unfreezing. The Platform has the right to decide whether to unfreeze based on its own judgment and reserves the right of final decision.",
		"titleInfo30": "1.3 Voluntary User Termination.",
		"titleInfo31": "Users may apply to close their accounts through the process provided by the Platform. Account closure must meet the following conditions:",
		"titleInfo32": "a. No outstanding transactions or disputes in the account;",
		"titleInfo33": "b. No remaining assets in the account;",
		"titleInfo34": "c. Not under judicial investigation, regulatory review or platform risk control restriction status;",
		"titleInfo35": "Once an account is closed, it cannot be restored; relevant data will be processed in accordance with applicable laws, regulations and the Platform's Privacy Policy.",
		"titleInfo36": "1.4 Platform Account Termination.",
		"titleInfo37": "If the Platform reasonably determines that any of the following circumstances exist, the Platform has the right to unilaterally terminate the account and reclaim usage rights without obtaining user consent:",
		"titleInfo38": "a. The account violates this Agreement or relevant laws, or poses significant compliance risks;",
		"titleInfo39": "b. The account has not conducted any Platform Activities for three consecutive years, and the Platform deems the user has abandoned the account;",
		"titleInfo40": "c. Account identity information is false, impersonates another person, or is a duplicate registration;",
		"titleInfo41": "d. The account engages in any conduct that harms the interests, reputation or security of the Platform;",
		"titleInfo42": "e. Other reasonable grounds determined by the Platform for account recovery.",
		"titleInfo43": "After the Platform terminates the account, it will decide whether to return any remaining lawful assets in the account based on the circumstances. If the account has engaged in illegal activities or other conduct detrimental to the Platform's interests, the Platform has the right to deduct relevant losses before refunding.",
		"titleInfo44": "2. Information and Communication",
		"titleInfo45": "2.1 Identity Verification.",
		"titleInfo46": "You are required to follow our identity verification procedures before opening an account by providing us with certain information about yourself, and where relevant, information about any permitted third-party users. All information you provide must be complete, accurate and true. You must update such information if it changes.",
		"titleInfo47": "You authorize us, directly or through third parties, to make any inquiries we consider necessary to verify your identity and the identity of any permitted third-party users, to protect you and/or us from the risks of fraud, money laundering, terrorist financing or other criminal activities, and to take any measures we deem necessary based on the results of such inquiries.",
		"titleInfo48": "When we make inquiries, you acknowledge and agree that your personal information and that of any permitted third-party users may be disclosed to identity verification, compliance data recording, credit reference, fraud prevention or financial crime agencies, which may fully respond to our inquiries.",
		"titleInfo49": "2.2 Enhanced Due Diligence.",
		"titleInfo50": "We may require you to comply with our enhanced due diligence procedures by submitting additional information about you, your business or any permitted third-party users, providing additional records or documents, or meeting face-to-face with an authorized representative of RWA Group.",
		"titleInfo51": "2.3 Information Requests",
		"titleInfo52": "To comply with any applicable law, identity verification requirements, detect money laundering, terrorist financing, fraud or any other crime, or for other valid reasons, we may request information from you at any time. You agree to provide the relevant information requested by us and authorize us to retain records of this information for up to six (6) years.",
		"titleInfo53": "2.4 Communication via Registered Email.",
		"titleInfo54": "You acknowledge the obligation to check your email, including spam folders. Information sent unilaterally by RWA Group shall be deemed effectively communicated to you from the time of sending. Failure to respond or take action within seven (7) business days after sending shall be deemed as you having no objection and agreeing to the content stated in that email.",
		"titleInfo55": "We may send notices with legal effect or consequences, or other notifications, to your registered email address. You are responsible for ensuring that your email address is current and accurate. Notices are deemed delivered once sent to the email address you provided. You bear sole responsibility for any legal consequences arising from your failure to update your email address promptly or to check your emails in a timely manner. You may send notices to us only in the manner we may direct from time to time.",
		"titleInfo56": "2.5 Announcements.",
		"titleInfo57": "All official announcements, including but not limited to those regarding promotions, contests and airdrops, will be posted on the Platform. These announcements are important and may be relevant to your decision-making regarding Platform Circulating Token activities. You are responsible for regularly visiting the Platform to check relevant announcements, regardless of whether such announcements are made before or after your corresponding actions. You bear sole responsibility for any legal consequences arising from failing to check announcements in a timely manner.",
		"titleInfo58": "2.6. Recordings.",
		"titleInfo59": "You agree that we may record communications with you through any means (including but not limited to electronic communications, telephone or face-to-face conversations) and confirm that such recordings may be used as valid evidence of the communications between the parties. You agree that telephone calls may be recorded without a beep or further notice.",
		"titleInfo60": "3. Prohibited Activities. If users are found or reasonably suspected by the Platform of engaging in the following prohibited activities, the Platform has the right to immediately take measures including but not limited to restricting transactions, freezing accounts, terminating accounts, reclaiming tokens and terminating services, and reserves the right to pursue legal liability according to law. Without affecting any other limitations or restrictions in this Agreement, you agree that you and any third-party users will not:",
		"titleInfo61": "a. Violate this Agreement or any agreement reached pursuant to this Agreement and related agreements (including but not limited to any Product Agreement);",
		"titleInfo62": "b. Engage in any Platform Circulating Token activities for investment purposes, treat Platform Circulating Tokens as any investment product; act in any way intentionally or objectively that would cause Platform Circulating Tokens to be deemed investment products; or engage in any activity that increases the risk of Platform Circulating Tokens being deemed investment products by regulatory authorities in any jurisdiction;",
		"titleInfo63": "c. Make any false, disparaging, or defamatory",
		"titleInfo64": "adverse, critical or derogatory",
		"titleInfo65": "statements, allegations or comments (whether express or implied) about us to third parties or publicly, unless such statements are based on objective facts and have received support from a valid judgment or ruling;",
		"titleInfo66": "d. Engage in activities on the Platform in a manner that violates public interest, public morality or the lawful interests of others;",
		"titleInfo67": "e. Engage in market manipulation (such as pump and dump, wash trading, matched orders, front running, quote stuffing, spoofing or layering), whether or not prohibited by applicable law;",
		"titleInfo68": "f. Engage in fraudulent activities, or cause us to suspect that you or any authorized users are engaged in fraudulent activities and/or transactions;",
		"titleInfo69": "g. Use Platform Circulating Tokens to conduct or participate in lotteries, gambling activities, auction fee bidding, sports predictions or odds-making, virtual sports leagues with cash prizes, online games, contests, sweepstakes or any games of chance not organized or supervised by us;",
		"titleInfo70": "h. Provide false, inaccurate or misleading information in connection with your activities on Platform Circulating Tokens, communications with us, or other matters related to this Agreement;",
		"titleInfo71": "i. Modify or adapt all or any part of the Platform, or merge or incorporate the Platform into other programs or applications;",
		"titleInfo72": "j. Modify, copy, duplicate, download, store, transmit, disseminate, transfer, disassemble, broadcast, publish, delete or alter any copyright notices or labels, or license, sublicense, sell, mirror, design, lease, sell, privatize, grant security interests in the intellectual property or any part thereof, or create derivative works, or in any way exploit any part of the intellectual property for profit;",
		"titleInfo73": "k. Violate or attempt to violate (i) any applicable law, (ii) the copyright, patent, trademark, trade secret or other intellectual property rights of us or any third party, or (iii) public rights or privacy rights.",
		"titleInfo74": "4. Material Interests and Conflicts of Interest",
		"titleInfo75": "4.1 Material Interests.",
		"titleInfo76": "You understand and agree that RWA Group is under no obligation to disclose to you or use for your benefit any information known to it, and is not liable for any consequences arising from such non-disclosure or non-use.",
		"titleInfo77": "You further acknowledge that we may from time to time receive any information about Platform Circulating Tokens or Platform Activities that may affect the price or liquidity of the tokens. We may lawfully use such information for our own activities or interests.",
		"titleInfo78": "4.2 RWA Group Activities.",
		"titleInfo79": "RWA Group or any employees authorized by it may engage in activities related to Platform Circulating Tokens. Although such activities are based on legitimate purposes (including but not limited to providing token liquidity, preventing third-party malicious market manipulation, etc.), you understand and agree that these activities constitute a potential conflict of interest with you.",
		"titleInfo80": "4.3. Liquidity Providers",
		"titleInfo81": "You acknowledge, agree and accept that:",
		"titleInfo82": "a. We may appoint one or more liquidity providers (which may include RWA Group itself) to monitor and adjust the market for Platform Circulating Tokens, and any such liquidity provider may enter into any transaction with you as your counterparty;",
		"titleInfo83": "b. Liquidity providers may also hold positions in various virtual assets (including Platform Circulating Tokens, etc.) in the course of their liquidity providing activities, including virtual asset positions contrary to yours;",
		"titleInfo84": "c. Such liquidity provision activities may be conducted through algorithmic trading. Such liquidity provision may affect the price of Platform Circulating Tokens and the liquidity required to execute transactions;",
		"titleInfo85": "d. Liquidity provision is based on legitimate purposes (e.g., maintaining platform market stability, preventing third-party malicious market manipulation, etc.). You shall not make any legal claims, claims for damages or applications for injunctions against us or relevant persons due to liquidity provision activities;",
		"titleInfo86": "e. We may realize profits or may face losses when providing liquidity; such profits or losses do not constitute any obligation or liability to users.",
		"titleInfo87": "5. Purchase and Consumption of Platform Circulating Tokens",
		"titleInfo88": "Information displayed on the Platform regarding Platform",
		"titleInfo89": "Circulating Tokens, goods or services",
		"titleInfo90": "the nature, quality and price of such information is for display purposes only, does not constitute an offer, and is at most an invitation to treat issued by the seller or token issuer specified in the specific Product Agreement.",
		"titleInfo91": "When you purchase or consume Platform Circulating Tokens on the Platform to redeem goods or services, please carefully confirm important details such as the product name, price, quantity, model, specification and size of the goods or services being redeemed, or the scope, content and duration of rights, or restrictions on the redeeming party, and verify your account name, email address and shipping address when placing the redemption order. If the shipping information you fill in is not for yourself, the consignee's actions and representations shall be deemed your actions and representations, and you shall be jointly and severally liable for the legal consequences of the consignee's actions and representations.",
		"titleInfo92": "Your consumption behavior should be based on genuine consumption needs and must not involve malicious purchasing of goods or services, malicious rights protection, malicious speculation or other acts that disrupt the normal trading order of the platform. To maintain the trading order and security of the platform, RWA Group has the right to take measures including but not limited to closing orders, restricting accounts, freezing assets, etc. upon discovery of the above situations.",
		"titleInfo93": "Unless expressly stated to the contrary, when you purchase, trade, or consume Platform Circulating Tokens on the Platform to redeem physical goods or services or engage in other Platform Activities, only the legal relationship between you and the seller or token issuer is involved, and RWA Group shall not in any way be deemed a participant in that legal relationship. We also do not make any express or implied representations or warranties regarding the relevant Platform Circulating Tokens, rights represented by the tokens (goods, services or other non-financial interests), including but not limited to the successful redemption of tokens, merchantability of corresponding goods or services, or fitness for a particular purpose.",
		"titleInfo94": "You agree that under no circumstances shall you bring any legal charges, claims for damages or injunctions of significance against RWA Group based on token consumption behaviors or other Platform Activities.",
		"titleInfo95": "6. Technical Disclaimer",
		"titleInfo96": "6.1 No Representations or Warranties.",
		"titleInfo97": "Any information provided by us through the Platform and any communications between you and us are provided on an \"as is\" and \"as available\" basis, without any representations or warranties of any kind, either express or implied, regarding accuracy, completeness or timeliness. The foregoing disclaimer is effective to the fullest extent permitted by applicable law.",
		"titleInfo98": "Specifically, we disclaim all implied warranties, including but not limited to warranties of title, merchantability, fitness for a particular purpose and/or non-infringement. We do not warrant or represent that your access to or use of the Platform and related communications will be uninterrupted, stable or timely, or that any materials provided in connection therewith will be complete or error-free. This may result in your inability to engage in Platform Circulating Token-related activities for a period of time and may cause delays in relevant transaction times.",
		"titleInfo99": "6.2 Suspension of Access. We may suspend your access to or use of the Platform from time to time for scheduled or emergency security maintenance.",
		"titleInfo100": "7. Changes to this Agreement and the Platform. We may modify this Agreement and any content on the Platform, including the functions and content of Platform Circulating Tokens and related activities, at any time at our sole discretion.",
		"titleInfo101": "By registering a Platform account or continuing to access or use the Platform, or by purchasing, holding, consuming or transferring Platform Circulating Tokens, you are deemed to have fully read, understood and agreed to be bound by the updated Agreement.",
		"titleInfo102": "If you do not wish to accept any changes, you should immediately cease holding Platform Circulating Tokens and cease any Platform Activities, and close your account by contacting relevant personnel of RWA Group.",
		"titleInfo103": "8. Compliance Cooperation. You agree to cooperate with RWA Group in any investigations and adjustments concerning Platform Circulating Tokens or Platform Activities for compliance purposes. If any regulatory authority contacts you regarding Platform Circulating Tokens or related activities, you agree to promptly notify RWA Group to the extent permitted by applicable law and provide all relevant information.",
		"titleInfo104": "9. Representations and Warranties. You hereby represent and warrant to us that you will always comply with the following:",
		"titleInfo105": "a. You have, through self-study or consultation with qualified legal or other professional advisors, fully understood the nature and any risks of the Platform's business and Platform Circulating Tokens;",
		"titleInfo106": "b. All documents and information you provide to us are true, accurate, complete and up-to-date in all respects, and we may rely on such information in all circumstances;",
		"titleInfo107": "c. All decisions related to this Agreement are based solely and entirely on your own judgment, made after your independent assessment of your financial resources, capabilities, willingness to assume relevant risks and financial objectives;",
		"titleInfo108": "d. You have full power, authority and capacity to:",
		"titleInfo109": "a) Access and use the Platform;",
		"titleInfo110": "b) Engage in any activities involving Platform Circulating Tokens;",
		"titleInfo111": "c) You have obtained all necessary third-party consents, licenses, authorizations, approvals and agreements, and all required or desired approvals, consents, licenses, registrations, declarations and filings with government regulatory authorities, government departments, commissions, agencies or other organizations having jurisdiction, in order to:",
		"titleInfo112": "a) Access and use the Platform;",
		"titleInfo113": "b) Engage in any activities involving Platform Circulating Tokens;",
		"titleInfo114": "10. Nature of Our Duties.",
		"titleInfo115": "You understand and agree that the relationship between you and RWA Group, or any other matter (including but not limited to your deposit of funds into your Platform account), does not constitute any fiduciary, trust, agency or partnership relationship, and we do not owe you any fiduciary duties. RWA Group has the right to reasonably adjust the prices and related parameters of any Platform Circulating Tokens, products or services for internal or external business reasons without prior notice to you.",
		"titleInfo116": "We also do not provide any investment, legal, tax, accounting or financial advice, and do not make any warranties regarding the market performance of Platform services, Platform Circulating Tokens and Platform Activities, nor regulatory approvals. You should independently exercise judgment, decision-making and compliance obligations in the relevant jurisdictions and acknowledge that you understand and accept the risks associated with using the Platform and trading Platform Circulating Tokens.",
		"titleInfo117": "Unless specifically stated otherwise, we shall not in any way be deemed the issuer of Platform Circulating Tokens and/or the seller of the represented rights and interests; we only establish a communication channel between the issuer of Platform Circulating Tokens and/or the seller of the represented rights and interests and users.",
		"titleInfo118": "11. Indemnification.",
		"titleInfo119": "You hereby covenant and agree to fully indemnify us and hold us harmless from any claims, and liabilities, damages (including actual and indirect damages), losses (including any direct or indirect monetary loss, reputational loss, etc.), costs and expenses, including but not limited to all interest, penalties and legal and other reasonable attorneys' fees and other professional fees (\"Indemnified Losses\"), brought against us by any third party, government agency or industry organization, arising out of or in any way related to any of the following:",
		"titleInfo120": "a. Your access to or use of the Platform or any activities involving Platform Circulating Tokens;",
		"titleInfo121": "b. Your breach or alleged breach of this Agreement or other related agreements, including any Product Agreement;",
		"titleInfo122": "c. Your violation of any applicable law;",
		"titleInfo123": "d. Your infringement of any third party rights.",
		"titleInfo124": "12. Liability",
		"titleInfo125": "12.1 Our Liability.",
		"titleInfo126": "To the maximum extent permitted by applicable law, RWA Group shall not be liable to you or any third party for any direct or indirect losses suffered as a result of Platform Activities or Platform Circulating Tokens. Without prejudice to the foregoing, in no event shall the total liability of RWA Group exceed the amount of fees paid by you to RWA Group in the twelve (12) months preceding the event giving rise to the loss. Such amount shall be paid by us to you as full and final settlement of all losses and claims, and shall be sufficient to release us from all liability for such losses and claims. You acknowledge and agree that RWA Group is unaware of any special circumstances relating to you, and that the aforementioned monetary compensation is your sole and exclusive remedy and you waive any right to or forego any other claims or remedies under law or equity, including but not limited to any damages, and/or specific performance.",
		"titleInfo127": "12.2 Limitation of Liability.",
		"titleInfo128": "Notwithstanding any other provisions in this Agreement, you hereby acknowledge and agree that in no event shall we be liable to you or any other person or entity for:",
		"titleInfo129": "a. Any direct or indirect losses (including monetary loss, loss of business opportunity, etc.), whether arising from or in connection with:",
		"titleInfo130": "a) Any of the risks identified in the Risk Warnings (as may be updated from time to time);",
		"titleInfo131": "b) The operation, functionality, security or availability of the underlying protocols of Platform Circulating Tokens or other virtual assets involved in Platform Activities;",
		"titleInfo132": "c) Any act or omission pursuant to this Agreement;",
		"titleInfo133": "d) Inaccuracies, defects or omissions in any data form, transmission errors or delays of any such data, and interruptions of any such data;",
		"titleInfo134": "e) Scheduled or unscheduled maintenance conducted by us, including service interruptions and changes resulting therefrom;",
		"titleInfo135": "f) The acts, omissions or breaches of this Agreement by other users, and damages caused by the acts of any other third parties;",
		"titleInfo136": "g) Any termination, suspension, and/or restriction of access to Platform Activities;",
		"titleInfo137": "h) Our inability to contact you using the contact information you provided;",
		"titleInfo138": "i) Our refusal or delay in executing any instructions;",
		"titleInfo139": "j) Losses you suffer due to third-party conduct, including third-party fraud involving RWA Group or Platform Circulating Tokens;",
		"titleInfo140": "k) Any blockchain network events, Forks or Airdrops;",
		"titleInfo141": "l) The correctness, quality, accuracy, security, completeness, reliability, performance, timeliness, pricing or continuing availability of the products or services provided by the Platform or us; delays, omissions or errors in any content provided by the Platform or us;",
		"titleInfo142": "m) Any transactions, instructions or operations you conduct on the Platform.",
		"titleInfo143": "b. Any special, and incidental, indirect or consequential loss or damage, whether arising from or in connection with our Platform, Platform Circulating Tokens, this Agreement, Product Agreements, and/or any agreement pursuant to or in connection with this Agreement;",
		"titleInfo144": "c. Any loss or damage you may suffer as a result of and/or any transaction cancellation/modification, whether direct or indirect, special or consequential, including but not limited to monetary loss and loss of opportunity; and/or",
		"titleInfo145": "d. Any claim not commenced by formal legal action within one year from the date the matter giving rise to the claim occurred.",
		"titleInfo146": "12.3. Communication First.",
		"titleInfo147": "You agree that in the event of any dispute with us, you will first contact us to communicate all circumstances regarding the dispute before contacting any regulatory authority or judicial body, and you agree not to disclose any information related to the dispute to any third party.",
		"titleInfo148": "13. Governing Law and Dispute Resolution.",
		"titleInfo149": "This Agreement shall be governed by and construed in accordance with the laws of the Hong Kong Special Administrative Region. You agree to submit all such disputes or claims to the exclusive jurisdiction of the courts of the Hong Kong Special Administrative Region and waive any objection to the jurisdiction of such courts.",
		"titleInfo150": "If RWA Group initiates legal proceedings against you, RWA Group will notify you via the email address you provided. You agree that any notice sent to such email address or mailing address shall be deemed valid, regardless of the adequacy of service. You are responsible for ensuring that the email address provided when registering your account is current and accurate.",
		"titleInfo151": "The parties agree that all information related to the legal proceedings shall remain confidential. Notwithstanding the foregoing, a party may disclose such confidential information in the following circumstances:",
		"titleInfo152": "a. With the written consent of the other party;",
		"titleInfo153": "b. As required by applicable law or any competent regulatory or supervisory body, or by order of a court or other competent authority;",
		"titleInfo154": "c. If the relevant confidential information is no longer confidential and has entered the public domain through means other than a breach of this Agreement.",
		"titleInfo155": "14. Waiver of Class Action.",
		"titleInfo156": "You and RWA Group agree that any claims shall be brought solely on an individual basis and not as a plaintiff or class member in any class action or representative proceeding. You further agree to waive the right to pursue such claims as a class, and representative, or private attorney general action, to the extent permitted by applicable law. Individual claims may not be consolidated or merged into a single action without the consent of RWA Group. This waiver applies to the maximum extent permitted by applicable law.",
		"titleInfo157": "15. Termination.",
		"titleInfo158": "This Agreement shall be legally binding on you from the time you first access the Platform and shall remain in full force and effect until you formally close your account solely in accordance with the account closure procedures set forth in this Agreement, at which point this Agreement terminates. If, after termination, you access the Platform again, this Agreement shall become binding on you again. After termination, the provisions of this Agreement not involving the use of the Platform shall continue in effect, including but not limited to Clauses 8 through 14 of this Agreement (including Clauses 8 and 14 themselves).",
		"titleInfo159": "16. Miscellaneous",
		"titleInfo160": "16.1 Entire Agreement.",
		"titleInfo161": "This Agreement and any Product Agreements constitute the entire agreement between you and us. You acknowledge that you are not relying on any representation, and, warranty or guarantee (whether made negligently or innocently) unless expressly stated in this Agreement or any Product Agreement.",
		"titleInfo162": "16.2 Assignment.",
		"titleInfo163": "You may not assign or transfer any of your rights or obligations under this Agreement without our prior written consent. Any unauthorized assignment or transfer shall be null and void and shall not be binding on RWA Group. However, we may assign or transfer any rights or obligations under this Agreement to any other party from time to time, including but not limited to in connection with a merger, acquisition or other corporate reorganization of any entity of RWA Group.",
		"titleInfo164": "16.3. Severability.",
		"titleInfo165": "Each part of this Agreement shall be severable from other parts of this Agreement when determining its legality, and enforceability. If any part of this Agreement becomes illegal, and or unenforceable at any time, the legality, and enforceability of the remaining parts shall not be affected or impaired thereby.",
		"titleInfo166": "16.4 Language.",
		"titleInfo167": "For ease of reading, translations of this Agreement may be provided. Translated versions may be in languages other than English. However, the English version of this Agreement is the official version. You should ensure you fully understand the English version; any risks or losses arising from misunderstanding shall be borne solely by you.",
		"titleInfo168": "16.5 Survival.",
		"titleInfo169": "Notwithstanding that your activities on the Platform may have been suspended or terminated, this Agreement and any applicable Product Agreements shall continue to apply to you for as long as you have obligations or liabilities under this Agreement or any applicable Product Agreement.",
		"titleInfo170": "16.6. No Waiver.",
		"titleInfo171": "Any delay or omission by us in exercising any right or remedy under this Agreement shall not operate as a waiver of the future exercise of that right or remedy, or of any other right or remedy under this Agreement. The rights and remedies provided in this Agreement are cumulative and do not exclude any rights or remedies provided by applicable law. No waiver shall be effective unless made in writing and signed by RWA Group.",
		"titleInfo172": "16.7 Taxes.",
		"titleInfo173": "It is your responsibility to determine whether any taxes apply to the payments you make or receive, and to collect, and and pay the correct amount of tax to the relevant authorities. You agree that we are not responsible for determining whether any taxes apply to your Platform Circulating Token activities, and are not responsible for collecting, and or paying any taxes resulting from such activities. You shall independently declare and pay taxes arising from Platform Activities to the relevant tax authorities, and we do not assume any joint liability.",
		"titleInfo174": "16.8 Privacy.",
		"titleInfo175": "We are committed to ensuring that all personal data submitted through the Platform strictly complies with the relevant provisions of the Personal Data (Privacy) Ordinance (PDPO). You may from time to time be invited to provide personal data to RWA Group through the Platform or otherwise for various purposes. Personal information may include name, telephone number, mailing address or email address. RWA Group will specify the purposes of collection and use when inviting you to provide such information. Unless permitted or required by law, RWA Group will not disclose your personal data to any third party without your prior consent."
	},
	...enLocale
}
export default en;
